export default {
  'global.button.viewAll': 'Ver todas',
  'global.button.viewAll1': 'Ver todos',
  'global.button.cancel': 'Cancelar',
  'global.button.close': 'Cerrar',
  'global.button.add1': 'Adicionar',
  'global.button.add': 'Agregar',
  'global.button.back': 'Volver',
  'global.button.refresh': 'Actualizar',
  'global.button.save': 'Guardar',
  'global.button.confirm': 'Confirmar',
  'global.button.delete': 'Eliminar',
  'global.button.edit': 'Editar',
  'global.button.test': 'Probar',
  'global.button.publish': 'Publicar',
  'global.button.continues': 'Continuar',
  'global.button.restore': 'Restaurar',
  'global.button.reject': 'Rechazar',
  'global.button.detail': 'Detalles',
  'global.button.delegatedTask': 'Tareas Delegadas',
  'global.button.approved': 'Aprobar',
  'global.button.complete': 'Completar',
  'global.button.execution': 'Ejecutada',
  'global.button.signature': 'Firmar',
  'global.button.send': 'Enviar',
  'global.button.toLogin': 'Ir al login',
  'global.button.toHome': 'Ir al Inicio',
  'global.button.enter': 'Acceder',
  'global.button.ms365': 'Microsoft',
  'global.button.rememberMe': 'Recordar',
  'global.button.copy': 'Copiar',
  'global.button.reset.password': 'Crear nueva contraseña',
  'global.button.sendCode': 'Enviar Código',
  'global.button.addForm': 'Crear Formulario',
  'global.button.export': 'Exportar',
  'global.button.import': 'Importar',
  'global.button.tasks': 'Tareas',
  'global.button.createRequest': 'Crear Solicitud',
  'global.button.viewDetails': 'Ver Detalles',
  'global.button.cancelRequest': 'Cancelar Solicitud',
  'global.button.completeRequestInformation': 'Completar Información de Solicitud',
  'global.button.approveRequest': 'Aprobar Solicitud',
  'global.button.executeTask': 'Ejecutar Tarea',
  'global.button.signDocument': 'Firmar Documento',
  'global.button.reassignTask': 'Reasignar Tarea',
  'global.button.massRequestApprove': 'Aprobar Solicitudes',
  'global.button.massRequestReject': 'Rechazar Solicitudes',
  'global.button.initApplication': 'Iniciar Solicitud',
  'global.button.erase': 'Limpiar',
  'global.button.undo': 'Deshacer',
  'global.button.redo': 'Rehacer',
  'global.text.radius.brush': 'Radio del puntero',
  'global.button.approve': 'Aprobar',
  'global.button.toFilter': 'Filtrar',
  'global.button.apply': 'Aplicar',
  'global.button.resetFilters': 'Limpiar Filtros',
  'global.button.no': 'No',
  'global.button.yes': 'Sí',
  'global.button.signIn': 'Iniciar sesión',
  'global.button.cleanup': 'Borrar',
  'global.button.download': 'Descargar',
  'global.button.print': 'Imprimir',
  'global.button.next': 'Siguiente',
  'global.button.previous': 'Atrás',
  'global.button.google': 'Google',
  'global.button.backInAutomy': 'Ingresar a',
  'global.button.saveAndComplete': 'Completar',
  'global.button.extraFields': 'Campos extra',
  'global.button.sendAccountConfirmationEmail': 'Confirmación de Cuenta',
  'global.button.confirmAccount': 'Confirmar Cuenta',
  'global.button.sendPasswordRecoveryEmail': 'Recuperar Contraseña',
  'global.button.resetPassword': 'Restablecer Contraseña',
  'global.button.unlockAccount': 'Desbloquear Cuenta',
  'global.button.setDefaultUser': 'Establecer como Predeterminado',
  'global.button.generate': 'Generar',
  'global.button.retry': 'Reintentar',
  'global.button.import': 'Importar',
  'global.button.export': 'Exportar',
  'global.button.purge': 'Borrar Datos',
  'global.restore.confirmQuestion': '¿Deseas restaurarlo?',
  'global.restore.restoreButton': 'Restaurar',
  // Canvas actions
  'action.config.beautify': 'Embellecer',
  'action.canvas.fit': 'Ajustar',
  'action.canvas.center': 'Centrar',
  'action.canvas.reset': 'Restablecer',
  'action.canvas.zoomIn': 'Acercar',
  'action.canvas.zoomOut': 'Alejar',
  'action.canvas.addNote': 'Agregar Nota',
  'action.canvas.fullscreen': 'Pantalla completa',
  'action.canvas.exitFullscreen': 'Salir de pantalla completa',
  'action.generate.ai.coming.soon': 'Genera AI (próximamente)',
  'global.button.loadExcel': 'Cargar Excel',
  'global.button.addGroup': 'Agregar Grupo',
  'global.button.removeCondition': 'Eliminar Condición',
  'global.button.company': 'Cambiar Empresa',
  'global.button.environment': 'Cambiar Entorno',
  'global.button.moreDetail': 'Mas Detalles',
  'global.button.lessDetail': 'Menos Detalles',
  'global.text.contentTooLarge':
    'El contenido es demasiado grande para mostrarse. Por favor, descárguelo para verlo.',
  'global.button.pin': 'Enviar PIN de Aprobación',
  'global.button.myDay.add': 'Agregar a Mi día',
  'global.button.mark.important': 'Marcar como Importante',
  'global.button.mark.completed': 'Marcar como Completada',
  'global.button.info': 'Información',
  'global.button.move': 'Mover a...',
  'global.button.delete': 'Eliminar',
  'global.button.create.list': 'Crear Lista',
  'global.button.accountConfirm': 'Confirmar Cuenta',
  'global.button.create': 'Crear',
  'global.button.create.task': 'Crear Tarea',
  'global.button.accountConfirm': 'Confirmar Cuenta',
  'global.button.details': 'Detalles',
  'global.button.editGridMode': 'Editar',
  'global.button.exitGridMode': 'Salir Modo Edición',
  'global.button.data': 'Datos',

  'global.status.sent': 'Enviadas',
  'global.status.sent1': 'Enviada',
  'global.status.received': 'Recibidas',
  'global.status.received1': 'Recibida',
  'global.status.pending': 'Pendientes',
  'global.status.pending1': 'Pendiente',
  'global.status.running': 'En ejecución',
  'global.status.canceled': 'Canceladas',
  'global.status.canceled1': 'Cancelada',
  'global.status.approved': 'Aprobadas',
  'global.status.approved1': 'Aprobada',
  'global.status.rejected': 'Rechazadas',
  'global.status.rejected1': 'Rechazada',
  'global.status.voided': 'Anuladas',
  'global.status.voided1': 'Anulada',
  'global.status.required': 'Requerido',
  'global.status.noRequired': 'No Requerido',
  'global.status.execution': 'Ejecución',
  'global.status.error': 'Error',
  'global.status.processing': 'Procesando',
  'global.status.processed': 'Procesado',
  'global.status.processingTaskItems': 'Procesando Tareas',

  'global.text.agent': 'Agente IA',
  'global.copyright': 'Todos los derechos reservados',
  'global.text.copyright': 'Copyright',
  'global.text.add': 'Agregar',
  'global.text.remove': 'Eliminar',
  'global.text.update': 'Actualizar',
  'global.text.activate': 'Activar',
  'global.text.detail': 'Detalle',
  'global.text.detail1': 'Detalles',
  'global.text.summary': 'Resumen',
  'global.text.events': 'Eventos',
  'global.text.eventHistory': 'Historial de eventos',
  'global.text.eventHistory.summary': 'Cronología de entrega y seguimiento de este correo.',
  'global.text.application': 'Solicitud',
  'global.text.completed': 'Completada',
  'global.text.edit': 'Editar',
  'global.text.cancel': 'Cancelar',
  'global.text.processes': 'Procesos',
  'global.text.groups': 'Grupos',
  'global.text.items': 'Elementos',
  'global.text.entities': 'Entidades',
  'global.text.premiumEntities': 'Entidades Premium',
  'global.text.premium': 'Premium',
  'global.text.basic': 'Básica',
  'global.text.showList': 'Mostrar Lista',
  'global.text.viewReport': 'Ver Reporte',
  'global.text.favorites': 'Favoritos',
  'global.text.list': 'Lista',
  'global.text.lists': 'Listas',
  'global.text.report': 'Reporte',
  'global.text.reports': 'Reportes',
  'global.text.adminReports': 'Sistema',
  'global.text.group': 'Grupo',
  'global.text.all': 'Todos',
  'global.text.all1': 'Todas',
  'global.text.advancedFilter': 'Filtro avanzado',
  'global.text.hideFilter': 'Ocultar filtro',
  'global.text.search': 'Buscar',
  'global.text.filters': 'Filtros',
  'global.filters.clearAll': 'Limpiar todos',
  'global.button.remove': 'Quitar',
  'configList.hero.description':
    'Configure y gestione {resource} organizacionales disponibles en toda la plataforma.',
  'configList.hero.description.readOnly': 'Consulte {resource} registrados en toda la plataforma.',
  'configList.hero.resource.areas': 'las áreas',
  'configList.hero.resource.positions': 'los puestos',
  'configList.hero.resource.customListGroups': 'los grupos de listas',
  'configList.hero.resource.dynamicEntityGroups': 'los grupos de entidades dinámicas',
  'configList.hero.resource.media': 'los elementos de media',
  'configList.hero.resource.mediaCategories': 'las categorías de media',
  'configList.hero.resource.processGroups': 'los grupos de procesos',
  'configList.hero.resource.connectionGroups': 'los grupos de conexiones',
  'configList.hero.resource.powerBiServers': 'los servidores Power BI',
  'configList.hero.resource.aiAgentTeams': 'los equipos de agentes IA',
  'configList.hero.resource.aiSkillGroups': 'los grupos de skills',
  'configList.hero.resource.userGroups': 'los grupos de usuarios',
  'configList.hero.resource.userDevices': 'los dispositivos',
  'configList.hero.resource.aiConsumptions': 'los consumos de IA',
  'configList.hero.resource.billingSubscriptions': 'las suscripciones',
  'configList.hero.resource.channelOperators': 'los operadores',
  'configList.hero.resource.channelDistributors': 'los distribuidores',
  'configList.hero.resource.channelPartners': 'los socios',
  'configList.hero.resource.channelResellers': 'los revendedores',
  'configList.hero.resource.channelReferralAgents': 'los agentes referidores',
  'configList.hero.resource.channelCustomerAssignments': 'las asignaciones de clientes',
  'configList.hero.resource.channelCustomers': 'los clientes',
  'configList.hero.resource.channelRegistrationApprovals': 'las solicitudes de registro',
  'configList.hero.resource.channelAgreements': 'los acuerdos comerciales',
  'configList.hero.resource.channelPlans': 'los planes',
  'configList.hero.resource.customerDiscounts': 'los descuentos de cliente',
  'configList.hero.resource.accessLog': 'los registros de acceso',
  'configList.hero.resource.accessPolicies': 'las políticas de acceso',
  'configList.hero.resource.securityEvents': 'los eventos de seguridad',
  'configList.hero.resource.shortenedUrls': 'las URLs abreviadas',
  'configList.hero.resource.traces': 'las trazas',
  'configList.hero.resource.emailMessageTraces': 'las trazas de correo',
  'configList.hero.resource.environments': 'los entornos',
  'configList.hero.resource.teamsMessageTraces': 'las trazas de mensajes Teams',
  'configList.hero.resource.smsMessageTraces': 'las trazas de mensajes SMS',
  'configList.hero.resource.reportGroups': 'los grupos de reportes',
  'configList.hero.resource.reports': 'los reportes',
  'configList.hero.resource.reportTokens': 'los tokens de reportes',
  'configList.hero.resource.sequences': 'las secuencias',
  'configList.hero.resource.approvers': 'los aprobadores',
  'configList.hero.resource.approversUserGroup': 'los aprobadores por grupo de usuarios',
  'configList.hero.resource.approversUserGroupPosition':
    'los aprobadores por grupo de usuarios y puesto',
  'configList.hero.resource.approversUserGroupArea': 'los aprobadores por grupo de usuarios y área',
  'configForm.hero.summary.add': 'Proporcione la información requerida para crear {resource}.',
  'configForm.hero.summary.copy': 'Proporcione la información requerida para crear {resource}.',
  'configList.hero.resource.approversEntityUser': 'los aprobadores por entidad y usuario',
  'configList.hero.resource.approversEntityUserGroup':
    'los aprobadores por entidad y grupo de usuarios',
  'configList.hero.resource.approversEntityPosition': 'los aprobadores por entidad y puesto',
  'configList.hero.resource.approversEntityArea': 'los aprobadores por entidad y área',
  'configList.hero.resource.emailFormats': 'los formatos de correo',
  'configList.hero.resource.extraUserFields': 'los campos extra de usuario',
  'configList.hero.resource.delegations': 'las delegaciones',
  'configList.hero.resource.processPortal': 'los portales de procesos',
  'configList.hero.resource.users': 'los usuarios',
  'configForm.hero.summary.edit': 'Actualice la información {resource}.',
  'configForm.hero.summary.details': 'Consulte la información {resource}.',
  'configForm.hero.stepProgress': 'Paso {current} de {total}',
  'configForm.hero.summary.resource.areas.add': 'una nueva área',
  'configForm.hero.summary.resource.areas.edit': 'del área seleccionada',
  'configForm.hero.summary.resource.areas.details': 'del área seleccionada',
  'configForm.hero.summary.resource.positions.add': 'un nuevo puesto',
  'configForm.hero.summary.resource.positions.edit': 'del puesto seleccionado',
  'configForm.hero.summary.resource.positions.details': 'del puesto seleccionado',
  'configForm.hero.summary.resource.customListGroups.add': 'un nuevo grupo de listas',
  'configForm.hero.summary.resource.customListGroups.edit': 'del grupo de listas seleccionado',
  'configForm.hero.summary.resource.customListGroups.details': 'del grupo de listas seleccionado',
  'configForm.hero.summary.resource.customLists.add': 'una nueva lista',
  'configForm.hero.summary.resource.customLists.edit': 'de la lista seleccionada',
  'configForm.hero.summary.resource.customLists.details': 'de la lista seleccionada',
  'configForm.hero.summary.resource.customListFields.add': 'un nuevo campo',
  'configForm.hero.summary.resource.customListFields.edit': 'del campo seleccionado',
  'configForm.hero.summary.resource.customListFields.details': 'del campo seleccionado',
  'configForm.hero.summary.resource.dynamicEntityGroups.add':
    'un nuevo grupo de entidades dinámicas',
  'configForm.hero.summary.resource.dynamicEntityGroups.edit':
    'del grupo de entidades dinámicas seleccionado',
  'configForm.hero.summary.resource.dynamicEntityGroups.details':
    'del grupo de entidades dinámicas seleccionado',
  'configForm.hero.summary.resource.entities.add': 'una nueva entidad',
  'configForm.hero.summary.resource.entities.edit': 'de la entidad seleccionada',
  'configForm.hero.summary.resource.entities.details': 'de la entidad seleccionada',
  'configForm.hero.summary.resource.projects.add': 'un nuevo proyecto',
  'configForm.hero.summary.resource.projects.edit': 'del proyecto seleccionado',
  'configForm.hero.summary.resource.projects.details': 'del proyecto seleccionado',
  'configForm.hero.summary.resource.projectArtifacts.add': 'la asociación de un recurso',
  'configForm.hero.summary.resource.projectArtifacts.edit': 'de la asociación seleccionada',
  'configForm.hero.summary.resource.projectArtifacts.details': 'de la asociación seleccionada',
  'configForm.hero.summary.resource.projectCollaborators.add': 'un nuevo colaborador',
  'configForm.hero.summary.resource.projectCollaborators.edit': 'del colaborador seleccionado',
  'configForm.hero.summary.resource.projectCollaborators.details': 'del colaborador seleccionado',
  'configForm.hero.summary.resource.entityRecords.add': 'un nuevo registro',
  'configForm.hero.summary.resource.entityRecords.edit': 'del registro seleccionado',
  'configForm.hero.summary.resource.entityRecords.details': 'del registro seleccionado',
  'configForm.hero.summary.resource.entityTokens.add': 'un nuevo token',
  'configForm.hero.summary.resource.entityTokens.edit': 'del token seleccionado',
  'configForm.hero.summary.resource.entityTokens.details': 'del token seleccionado',
  'configForm.hero.summary.resource.entityFields.add': 'un nuevo campo',
  'configForm.hero.summary.resource.entityFields.edit': 'del campo seleccionado',
  'configForm.hero.summary.resource.entityFields.details': 'del campo seleccionado',
  'configForm.hero.summary.resource.media.add': 'un nuevo media',
  'configForm.hero.summary.resource.media.edit': 'del media seleccionado',
  'configForm.hero.summary.resource.media.details': 'del media seleccionado',
  'configForm.hero.summary.resource.mediaCategories.add': 'una nueva categoría de media',
  'configForm.hero.summary.resource.mediaCategories.edit': 'de la categoría de media seleccionada',
  'configForm.hero.summary.resource.mediaCategories.details':
    'de la categoría de media seleccionada',
  'configForm.hero.summary.resource.processGroups.add': 'un nuevo grupo de procesos',
  'configForm.hero.summary.resource.processGroups.edit': 'del grupo de procesos seleccionado',
  'configForm.hero.summary.resource.processGroups.details': 'del grupo de procesos seleccionado',
  'configForm.hero.summary.resource.connectionGroups.add': 'un nuevo grupo de conexiones',
  'configForm.hero.summary.resource.connectionGroups.edit': 'del grupo de conexiones seleccionado',
  'configForm.hero.summary.resource.connectionGroups.details':
    'del grupo de conexiones seleccionado',
  'configForm.hero.summary.resource.connections.add': 'una nueva conexión',
  'configForm.hero.summary.resource.connections.edit': 'de la conexión seleccionada',
  'configForm.hero.summary.resource.connections.details': 'de la conexión seleccionada',
  'configForm.hero.summary.connections.configuration':
    'Proporcione las credenciales y opciones de la conexión {type}.',
  'configForm.hero.summary.resource.powerBiServers.add': 'un nuevo servidor Power BI',
  'configForm.hero.summary.resource.powerBiServers.edit': 'del servidor Power BI seleccionado',
  'configForm.hero.summary.resource.powerBiServers.details': 'del servidor Power BI seleccionado',
  'configForm.hero.summary.resource.aiAgentTeams.add': 'un nuevo equipo de agentes IA',
  'configForm.hero.summary.resource.aiAgentTeams.edit': 'del equipo de agentes IA seleccionado',
  'configForm.hero.summary.resource.aiAgentTeams.details': 'del equipo de agentes IA seleccionado',
  'configForm.hero.summary.resource.aiSkillGroups.add': 'un nuevo grupo de skills',
  'configForm.hero.summary.resource.aiSkillGroups.edit': 'del grupo de skills seleccionado',
  'configForm.hero.summary.resource.aiSkillGroups.details': 'del grupo de skills seleccionado',
  'configForm.hero.summary.resource.userGroups.add': 'un nuevo grupo de usuarios',
  'configForm.hero.summary.resource.userGroups.edit': 'del grupo de usuarios seleccionado',
  'configForm.hero.summary.resource.userGroups.details': 'del grupo de usuarios seleccionado',
  'configForm.hero.summary.resource.userDevices.add': 'un nuevo dispositivo',
  'configForm.hero.summary.resource.userDevices.edit': 'del dispositivo seleccionado',
  'configForm.hero.summary.resource.userDevices.details': 'del dispositivo seleccionado',
  'configForm.hero.summary.resource.aiConsumptions.details': 'del consumo de IA seleccionado',
  'configForm.hero.summary.resource.billingSubscriptions.details': 'de la suscripción seleccionada',
  'configForm.hero.summary.resource.channelOperators.details': 'del operador seleccionado',
  'configForm.hero.summary.resource.channelDistributors.details': 'del distribuidor seleccionado',
  'configForm.hero.summary.resource.channelPartners.details': 'del socio seleccionado',
  'configForm.hero.summary.resource.channelResellers.details': 'del revendedor seleccionado',
  'configForm.hero.summary.resource.channelReferralAgents.details':
    'del agente referidor seleccionado',
  'configForm.hero.summary.resource.channelCustomerAssignments.details':
    'de la asignación de cliente seleccionada',
  'configForm.hero.summary.resource.channelRegistrationApprovals.details':
    'de la solicitud seleccionada',
  'configForm.hero.summary.resource.channelAgreements.add': 'un nuevo acuerdo comercial',
  'configForm.hero.summary.resource.channelAgreements.edit': 'del acuerdo comercial seleccionado',
  'configForm.hero.summary.resource.channelAgreements.details':
    'del acuerdo comercial seleccionado',
  'configForm.hero.summary.resource.channelPlans.add': 'un nuevo plan',
  'configForm.hero.summary.resource.channelPlans.edit': 'del plan seleccionado',
  'configForm.hero.summary.resource.channelPlans.details': 'del plan seleccionado',
  'configForm.hero.summary.resource.customerDiscounts.add': 'un nuevo descuento de cliente',
  'configForm.hero.summary.resource.customerDiscounts.edit':
    'del descuento de cliente seleccionado',
  'configForm.hero.summary.resource.customerDiscounts.details':
    'del descuento de cliente seleccionado',
  'configForm.hero.summary.resource.accessLog.details': 'del registro de acceso seleccionado',
  'configForm.hero.summary.resource.accessPolicies.add': 'una nueva política de acceso',
  'configForm.hero.summary.resource.accessPolicies.edit': 'de la política de acceso seleccionada',
  'configForm.hero.summary.resource.accessPolicies.details':
    'de la política de acceso seleccionada',
  'configForm.hero.summary.resource.securityEvents.add':
    'una nueva suscripción de eventos de seguridad',
  'configForm.hero.summary.resource.securityEvents.edit': 'de la suscripción seleccionada',
  'configForm.hero.summary.resource.securityEvents.details': 'de la suscripción seleccionada',
  'configForm.hero.summary.resource.securityEventDestinations.add': 'un nuevo destino',
  'configForm.hero.summary.resource.securityEventDestinations.edit': 'del destino seleccionado',
  'configForm.hero.summary.resource.securityEventDestinations.details': 'del destino seleccionado',
  'configForm.hero.summary.resource.shortenedUrls.details': 'de la URL abreviada seleccionada',
  'configForm.hero.summary.resource.traces.details': 'de la traza seleccionada',
  'configForm.hero.summary.resource.reassignedTaskTraces.details':
    'de la tarea reasignada seleccionada',
  'configForm.hero.summary.resource.commandTraces.details': 'de la acción seleccionada',
  'configForm.hero.summary.resource.engineTasks.details': 'de la ejecución seleccionada',
  'configForm.hero.summary.resource.apiCallResults.details':
    'del resultado de la llamada API seleccionado',
  'configForm.hero.summary.resource.rpaCallResults.details':
    'del resultado de la llamada RPA seleccionado',
  'configForm.hero.summary.resource.automyAIResults.details':
    'del resultado de Automy IA seleccionado',
  'configForm.hero.summary.resource.internalOperationResults.details':
    'del resultado de la operación interna seleccionado',
  'configForm.hero.summary.resource.runCodeResults.details':
    'del resultado de la operación Run Code seleccionado',
  'configForm.hero.summary.resource.consumeSequenceResults.details':
    'del resultado de Consumir Secuencia seleccionado',
  'configForm.hero.summary.resource.conditionEvaluationResults.details':
    'del resultado de evaluación de condiciones seleccionado',
  'configForm.hero.summary.resource.iterationResults.details':
    'del resultado de iteración seleccionado',
  'configForm.hero.summary.resource.openAICallResults.details':
    'del resultado de la llamada Open AI seleccionado',
  'configForm.hero.summary.resource.emailMessageTraces.details':
    'de la traza de correo seleccionada',
  'configForm.hero.summary.resource.emailTrackingResults.details':
    'del resultado de trazas de entrega de correo seleccionado',
  'configForm.hero.summary.resource.setFormDataResults.details':
    'del resultado de establecer datos de formulario seleccionado',
  'configForm.hero.summary.resource.setVariableResults.details':
    'del resultado de establecer variable seleccionado',
  'configForm.hero.summary.resource.webhookOperationResults.details':
    'del resultado de la operación webhook seleccionado',
  'configForm.hero.summary.resource.waitChildRequestsResults.details':
    'del resultado de esperar solicitudes hijas seleccionado',
  'configForm.hero.summary.resource.aiBillingCredits.details': 'del crédito seleccionado',
  'configForm.hero.summary.resource.teamsMessageTraces.details':
    'de la traza de mensaje Teams seleccionada',
  'configForm.hero.summary.resource.smsMessageTraces.details':
    'de la traza de mensaje SMS seleccionada',
  'configForm.hero.summary.resource.dynamicEntityResults.details':
    'del resultado de la operación de entidad dinámica seleccionado',
  'configForm.hero.summary.resource.dynamicEntityQueryResults.details':
    'del resultado de consulta de entidad dinámica seleccionado',
  'configForm.hero.summary.resource.environments.add': 'un nuevo entorno',
  'configForm.hero.summary.resource.environments.edit': 'del entorno seleccionado',
  'configForm.hero.summary.resource.environments.details': 'del entorno seleccionado',
  'configForm.hero.summary.resource.users.add': 'un nuevo usuario',
  'configForm.hero.summary.resource.users.edit': 'del usuario seleccionado',
  'configForm.hero.summary.resource.users.details': 'del usuario seleccionado',
  'configForm.hero.summary.resource.reportGroups.add': 'un nuevo grupo de reportes',
  'configForm.hero.summary.resource.reportGroups.edit': 'del grupo de reportes seleccionado',
  'configForm.hero.summary.resource.reportGroups.details': 'del grupo de reportes seleccionado',
  'configForm.hero.summary.resource.reports.add': 'un nuevo reporte',
  'configForm.hero.summary.resource.reports.edit': 'del reporte seleccionado',
  'configForm.hero.summary.resource.reports.details': 'del reporte seleccionado',
  'configForm.hero.summary.resource.reportTokens.add': 'un nuevo token de reportes',
  'configForm.hero.summary.resource.reportTokens.edit': 'del token de reportes seleccionado',
  'configForm.hero.summary.resource.reportTokens.details': 'del token de reportes seleccionado',
  'configForm.hero.summary.resource.sequences.add': 'una nueva secuencia',
  'configForm.hero.summary.resource.sequences.edit': 'de la secuencia seleccionada',
  'configForm.hero.summary.resource.sequences.details': 'de la secuencia seleccionada',
  'configForm.hero.summary.resource.processes.add': 'un nuevo proceso',
  'configForm.hero.summary.resource.processes.edit': 'del proceso seleccionado',
  'configForm.hero.summary.resource.processes.details': 'del proceso seleccionado',
  'configForm.hero.summary.resource.apps.add': 'una nueva app',
  'configForm.hero.summary.resource.apps.copy': 'una copia de la app',
  'configForm.hero.summary.resource.apps.edit': 'de la app seleccionada',
  'configForm.hero.summary.resource.apps.details': 'de la app seleccionada',
  'configForm.hero.summary.resource.sites.add': 'un nuevo site',
  'configForm.hero.summary.resource.sites.edit': 'del site seleccionado',
  'configForm.hero.summary.resource.sites.details': 'del site seleccionado',
  'configForm.hero.summary.resource.aiAgents.add': 'un nuevo agente de IA',
  'configForm.hero.summary.resource.aiAgents.edit': 'del agente de IA seleccionado',
  'configForm.hero.summary.resource.aiAgents.details': 'del agente de IA seleccionado',
  'configForm.hero.summary.resource.agentGuardrails.edit': 'de los guardrails del agente',
  'configForm.hero.summary.resource.agentGuardrails.details': 'de los guardrails del agente',
  'configForm.hero.summary.resource.agentBehavior.edit': 'de la conducta del agente',
  'configForm.hero.summary.resource.agentBehavior.details': 'de la conducta del agente',
  'configForm.hero.summary.resource.agentAccessControl.edit': 'del control de acceso del agente',
  'configForm.hero.summary.resource.agentAccessControl.details': 'del control de acceso del agente',
  'configForm.hero.summary.resource.agentPermissions.edit': 'de los permisos del agente',
  'configForm.hero.summary.resource.agentPermissions.details': 'de los permisos del agente',
  'configForm.hero.summary.resource.agentGeneral.edit': 'de la configuración general del agente',
  'configForm.hero.summary.resource.agentGeneral.details': 'de la configuración general del agente',
  'configForm.hero.summary.resource.aiSkills.add': 'un nuevo skill',
  'configForm.hero.summary.resource.aiSkills.edit': 'del skill seleccionado',
  'configForm.hero.summary.resource.aiSkills.details': 'del skill seleccionado',
  'configForm.hero.summary.resource.aiVectors.add': 'un nuevo vector',
  'configForm.hero.summary.resource.aiVectors.edit': 'del vector seleccionado',
  'configForm.hero.summary.resource.aiVectors.details': 'del vector seleccionado',
  'configForm.hero.summary.resource.rpaAgents.add': 'un nuevo agente RPA',
  'configForm.hero.summary.resource.rpaAgents.edit': 'del agente RPA seleccionado',
  'configForm.hero.summary.resource.rpaAgents.details': 'del agente RPA seleccionado',
  'configForm.hero.summary.resource.aiAgentSchedules.add': 'un nuevo trabajo',
  'configForm.hero.summary.resource.aiAgentSchedules.edit': 'del trabajo seleccionado',
  'configForm.hero.summary.resource.aiAgentSchedules.details': 'del trabajo seleccionado',
  'configForm.hero.summary.apps.builder': 'Configure esta sección de la app.',
  'configForm.hero.summary.resource.approversUserGroup.add':
    'un nuevo aprobador por grupo de usuarios',
  'configForm.hero.summary.resource.approversUserGroup.edit':
    'del aprobador por grupo de usuarios seleccionado',
  'configForm.hero.summary.resource.approversUserGroup.details':
    'del aprobador por grupo de usuarios seleccionado',
  'configForm.hero.summary.resource.approversUserGroupPosition.add':
    'un nuevo aprobador por grupo de usuarios y puesto',
  'configForm.hero.summary.resource.approversUserGroupPosition.edit':
    'del aprobador por grupo de usuarios y puesto seleccionado',
  'configForm.hero.summary.resource.approversUserGroupPosition.details':
    'del aprobador por grupo de usuarios y puesto seleccionado',
  'configForm.hero.summary.resource.approversUserGroupArea.add':
    'un nuevo aprobador por grupo de usuarios y área',
  'configForm.hero.summary.resource.approversUserGroupArea.edit':
    'del aprobador por grupo de usuarios y área seleccionado',
  'configForm.hero.summary.resource.approversUserGroupArea.details':
    'del aprobador por grupo de usuarios y área seleccionado',
  'configForm.hero.summary.resource.subSequences.add': 'una nueva subsecuencia',
  'configForm.hero.summary.resource.approversEntityUser.add':
    'un nuevo aprobador por entidad y usuario',
  'configForm.hero.summary.resource.approversEntityUser.edit':
    'del aprobador por entidad y usuario seleccionado',
  'configForm.hero.summary.resource.approversEntityUser.details':
    'del aprobador por entidad y usuario seleccionado',
  'configForm.hero.summary.resource.approversEntityUserGroup.add':
    'un nuevo aprobador por entidad y grupo de usuarios',
  'configForm.hero.summary.resource.approversEntityUserGroup.edit':
    'del aprobador por entidad y grupo de usuarios seleccionado',
  'configForm.hero.summary.resource.approversEntityUserGroup.details':
    'del aprobador por entidad y grupo de usuarios seleccionado',
  'configForm.hero.summary.resource.approversEntityPosition.add':
    'un nuevo aprobador por entidad y puesto',
  'configForm.hero.summary.resource.approversEntityPosition.edit':
    'del aprobador por entidad y puesto seleccionado',
  'configForm.hero.summary.resource.approversEntityPosition.details':
    'del aprobador por entidad y puesto seleccionado',
  'configForm.hero.summary.resource.approversEntityArea.add':
    'un nuevo aprobador por entidad y área',
  'configForm.hero.summary.resource.approversEntityArea.edit':
    'del aprobador por entidad y área seleccionado',
  'configForm.hero.summary.resource.approversEntityArea.details':
    'del aprobador por entidad y área seleccionado',
  'configForm.hero.summary.resource.emailFormats.add': 'un nuevo formato de correo',
  'configForm.hero.summary.resource.emailFormats.edit': 'del formato de correo seleccionado',
  'configForm.hero.summary.resource.emailFormats.details': 'del formato de correo seleccionado',
  'configForm.hero.summary.resource.extraUserFields.add': 'un nuevo campo extra de usuario',
  'configForm.hero.summary.resource.extraUserFields.edit':
    'del campo extra de usuario seleccionado',
  'configForm.hero.summary.resource.extraUserFields.details':
    'del campo extra de usuario seleccionado',
  'configForm.hero.summary.resource.delegations.add': 'una nueva delegación',
  'configForm.hero.summary.resource.delegations.edit': 'de la delegación seleccionada',
  'configForm.hero.summary.resource.processPortal.add': 'un nuevo portal de procesos',
  'configForm.hero.summary.resource.processPortal.edit': 'del portal de procesos seleccionado',
  'configForm.hero.summary.resource.processPortal.details': 'del portal de procesos seleccionado',
  'configForm.hero.summary.resource.delegations.details': 'de la delegación seleccionada',
  'configForm.hero.summary.resource.delegationConfigurations.add': 'una nueva configuración',
  'configForm.hero.summary.resource.delegationConfigurations.edit':
    'de la configuración seleccionada',
  'configForm.hero.summary.resource.delegationConfigurations.details':
    'de la configuración seleccionada',
  'configForm.hero.summary.resource.subSequences.edit': 'de la subsecuencia seleccionada',
  'configForm.hero.summary.resource.subSequences.details': 'de la subsecuencia seleccionada',
  'configForm.hero.summary.resource.reportTokenTraces.details': 'de la traza seleccionada',
  'configForm.hero.summary.resource.internalTasks.details': 'de la tarea seleccionada',
  'configInternalTasks.description':
    'Supervise las operaciones de exportación en segundo plano de este módulo.',
  'configInternalTasks.operationType.export': 'Exportación',
  'configInternalTasks.operationType.import': 'Importación',
  'configInternalTasks.operationType.unknown': 'Operación desconocida',
  'configInternalTasks.field.taskOutput': 'Salida de la tarea',
  'configInternalTasks.field.timeZone': 'Zona horaria',
  'configInternalTasks.cancel.confirmContent':
    '¿Está seguro de que desea cancelar esta tarea pendiente?',
  'global.text.date': 'Fecha',
  'global.text.createdDate': 'Fecha de Creación',
  'global.smsDeliveryProvider.twilio': 'Twilio',
  'global.smsDeliveryProvider.sendblue': 'Sendblue',
  'global.sms.fromNumber': 'Número origen',
  'global.sms.destinationNumber': 'Número destino',
  'global.text.message': 'Mensaje',
  'global.text.destination': 'Destino',
  'global.text.channelId': 'ID canal',
  'global.messageStatus.queued': 'En cola',
  'global.messageStatus.processing': 'Procesando',
  'global.messageStatus.sent': 'Enviado',
  'global.messageStatus.error': 'Error',
  'global.messageStatus.skipped': 'Omitido',
  'global.messageStatus.failed': 'Fallido',
  'global.teams.conversationDestinationType': 'Destino conversación',
  'global.teams.internalConversationReferenceId': 'ID referencia conversación',
  'global.teams.messageFormat': 'Formato mensaje',
  'global.teamsConversationDestinationType.user': 'Usuario',
  'global.teamsConversationDestinationType.channel': 'Canal',
  'global.teamsConversationDestinationType.groupChat': 'Chat grupal',
  'global.teamsMessageFormat.text': 'Texto',
  'global.teamsMessageFormat.markdown': 'Markdown',
  'global.teamsMessageFormat.adaptiveCard': 'Tarjeta adaptativa',
  'global.text.updatedDate': 'Fecha de Actualización',
  'global.text.isPublic': '¿Público?',
  'global.text.user': 'Usuario',
  'global.text.system': 'Sistema',
  'global.text.users': 'Usuarios',
  'global.text.url': 'dirección url',
  'global.text.headers': 'Cabeceras',
  'global.text.key': 'Llave',
  'global.text.value': 'Valor',
  'global.mappingValueSource.FormField': 'Formulario / Campo',
  'global.mappingValueSource.Variable': 'Variable',
  'global.mappingValueSource.Formula': 'Fórmula',
  'global.mappingValueSource.FixedValue': 'Valor Fijo',
  'global.mappingValueSource.InternalField': 'Campo Interno',
  'global.mappingValueSource.IterationStepData': 'Iteración / Datos',
  'global.mappingValueSource.GeneratedDocument': 'Documento Generado',
  'global.text.host': 'Host',
  'global.text.port': 'Puerto',
  'global.text.position': 'Puesto',
  'global.text.userGroup': 'Grupo de Usuarios',
  'global.text.userGroups': 'Grupos de Usuarios',
  'global.text.userDevices': 'Dispositivos',
  'global.text.aiConsumptions': 'Consumos de IA',
  'global.text.billingSubscriptions': 'Suscripciones',
  'global.text.financialAdministration': 'Administración financiera',
  'global.text.customerDiscounts': 'Descuentos de cliente',
  'global.text.channelOperators': 'Operadores',
  'global.text.channelDistributors': 'Distribuidores',
  'global.text.channelPartners': 'Socios',
  'global.text.channelResellers': 'Revendedores',
  'global.text.channelReferralAgents': 'Agentes Referidores',
  'global.text.channelCustomerAssignments': 'Asignaciones de Clientes',
  'global.text.channelCustomers': 'Clientes',
  'global.text.channelRegistrationApprovals': 'Solicitudes de registro',
  'channelCustomers.description': 'Registre un cliente para la empresa activa.',
  'channelCustomers.empty': 'Pulse + para registrar un cliente.',
  'channelCustomers.actions.viewRecord': 'Ver ficha',
  'channelCustomers.sections.registrar': 'Actor registrador',
  'channelRegistrationApprovals.description':
    'Revise los registros de actores pendientes de AUTOMY.',
  'channelRegistrationApprovals.columns.requestedAt': 'Fecha',
  'channelRegistrationApprovals.columns.actorKind': 'Tipo',
  'channelRegistrationApprovals.columns.company': 'Empresa',
  'channelRegistrationApprovals.columns.registrar': 'Actor registrador',
  'channelRegistrationApprovals.columns.targetCompany': 'Empresa destino',
  'channelRegistrationApprovals.columns.parent': 'Padre',
  'channelRegistrationApprovals.parent.none': 'Sin padre comercial',
  'channelRegistrationApprovals.fields.requestedByCompany': 'Empresa solicitante',
  'channelRegistrationApprovals.fields.approvalRequired': 'Requiere aprobación de AUTOMY',
  'channelRegistrationApprovals.fields.rejectionReason': 'Motivo de rechazo',
  'channelRegistrationApprovals.fields.reviewNotes': 'Notas de revisión',
  'channelRegistrationApprovals.review.approve.message': '¿Aprobar este registro?',
  'channelRegistrationApprovals.review.approve.notifyHint':
    'Si el solicitante tiene correo, se le avisará. La invitación del administrador se envía después, por separado.',
  'channelRegistrationApprovals.review.reject.message': '¿Rechazar este registro?',
  'channelRegistrationApprovals.review.reject.notifyHint':
    'Si el solicitante tiene correo, se le avisará.',
  'channelRegistrationApprovals.review.notesPlaceholder': 'Notas de revisión',
  'channelRegistrationApprovals.review.rejectionReasonPlaceholder':
    'Explique por qué se rechaza este registro.',
  'channelRegistrationApprovals.conflict': 'La solicitud cambió. Recargue e inténtelo de nuevo.',
  'channelRegistrationApprovalStatus.pending': 'Pendiente',
  'channelRegistrationApprovalStatus.approved': 'Aprobado',
  'channelRegistrationApprovalStatus.rejected': 'Rechazado',
  'global.text.channelAgreements': 'Acuerdos Comerciales',
  'global.text.channelPlans': 'Planes',
  'channelCustomerAssignment.columns.customerCompany': 'Empresa cliente',
  'channelCustomerAssignment.columns.sourceType': 'Origen',
  'channelCustomerAssignment.fields.partnerId': 'Socio',
  'channelCustomerAssignment.fields.resellerId': 'Revendedor',
  'channelAgreement.columns.agreementType': 'Tipo de acuerdo',
  'channelAgreement.columns.approvalStatus': 'Estado de aprobación',
  'channelAgreement.columns.reviewedAt': 'Revisado',
  'channelAgreement.columns.ownerType': 'Propiedad',
  'channelAgreement.columns.ownerDistributorId': 'Distribuidor propietario',
  'channelAgreement.columns.payoutMode': 'Modo de payout',
  'channelAgreement.columns.commissionSettlementScope': 'Alcance de liquidación',
  'channelAgreement.fields.reviewedBy': 'Revisado por',
  'channelAgreement.fields.reviewNotes': 'Notas de revisión',
  'channelAgreement.fields.paymentIntervalValue': 'Intervalo de pago',
  'channelAgreement.fields.paymentIntervalValue.hint': '0 significa sin espera y sin bloque.',
  'channelAgreement.fields.paymentIntervalUnit': 'Unidad',
  'channelAgreement.paymentIntervalUnit.day': 'Días',
  'channelAgreement.paymentIntervalUnit.month': 'Meses',
  'channelAgreement.fields.settlementFrequency': 'Frecuencia de liquidación',
  'channelAgreement.fields.settlementFrequency.hint':
    'Cada cuánto se liquidan las comisiones de este acuerdo.',
  'channelAgreement.fields.minimumSettlementAmount': 'Monto mínimo de liquidación',
  'channelAgreement.fields.minimumSettlementAmount.hint': 'Vacío o 0 significa que no hay mínimo.',
  'channelAgreement.settlementFrequency.monthly': 'Mensual',
  'channelAgreement.settlementFrequency.weekly': 'Semanal',
  'channelAgreement.settlementFrequency.manual': 'Manual',
  'channelAgreement.settlementFrequency.immediate': 'Inmediata',
  'channelAgreement.ownerType.automy': 'AUTOMY',
  'channelAgreement.ownerType.distributor': 'Distribuidor',
  'channelAgreement.ownerType.globalAutomy': 'Global (AUTOMY)',
  'channelAgreement.ownerType.distributorPrivate': 'Privado de Distribuidor',
  'channelAgreement.approvalStatus.pendingReview': 'Pendiente de revisión',
  'channelAgreement.approvalStatus.approved': 'Aprobado',
  'channelAgreement.approvalStatus.rejected': 'Rechazado',
  'channelAgreement.payoutMode.stripeTransfer': 'Transferencia Stripe',
  'channelAgreement.payoutMode.manualSettlement': 'Liquidación manual',
  'channelAgreement.payoutMode.none': 'Ninguno',
  'channelAgreement.commissionSettlementScope.automyManaged': 'Gestionado por AUTOMY',
  'channelAgreement.commissionSettlementScope.externalManaged': 'Gestionado externamente',
  'channelAgreement.beneficiaryType.operator': 'Operador',
  'channelAgreement.beneficiaryType.distributor': 'Distribuidor',
  'channelAgreement.beneficiaryType.partner': 'Partner',
  'channelAgreement.beneficiaryType.reseller': 'Revendedor',
  'channelAgreement.beneficiaryType.referralAgent': 'Agente referidor',
  'channelAgreement.commissionableEventType.subscriptionInvoicePaid':
    'Factura de suscripción pagada',
  'channelAgreement.commissionableEventType.aiCreditPurchasePaid': 'Compra de créditos IA pagada',
  'channelAgreement.commissionableEventType.aiAutoRechargePaid': 'Recarga automática IA pagada',
  'channelAgreement.commissionableEventType.aiManualCreditPurchasePaid':
    'Compra manual de créditos IA pagada',
  'channelAgreement.calculationType.percent': 'Porcentaje',
  'channelAgreement.calculationType.fixedAmount': 'Monto fijo',
  'channelAgreement.ruleFrequencyType.recurring': 'Recurrente',
  'channelAgreement.ruleFrequencyType.oneTime': 'Única vez',
  'channelAgreement.baseAmountType.amountPaid': 'Monto pagado',
  'channelAgreement.baseAmountType.planMonthlyFee': 'Tarifa mensual del plan',
  'channelAgreement.baseAmountType.netAfterDiscountBeforeTax': 'Neto antes de impuestos',
  'channelAgreement.commissionBaseType.netAmount': 'Monto neto',
  'channelAgreement.commissionBaseType.netAfterProviderFees':
    'Neto después de comisiones del proveedor',
  'channelAgreement.commissionBaseType.grossAmount': 'Monto bruto',
  'channelAgreement.commissionBaseType.margin': 'Margen',
  'channelAgreement.revenueType.subscription': 'Suscripción',
  'channelAgreement.revenueType.creditPurchase': 'Compra de créditos',
  'channelAgreement.revenueType.aiRecharge': 'Recarga de IA',
  'channelAgreement.revenueType.professionalServices': 'Servicios profesionales',
  'channelAgreement.revenueType.marketplace': 'Marketplace',
  'channelAgreement.revenueType.whatsAppConsumption': 'Consumo de WhatsApp',
  'channelAgreement.revenueType.smsConsumption': 'Consumo de SMS',
  'channelAgreement.revenueType.voiceConsumption': 'Consumo de voz',
  'channelAgreement.revenueType.storage': 'Almacenamiento',
  'channelAgreement.revenueType.other': 'Otro',
  'channelAgreement.rules.title': 'Reglas de comisión',
  'channelAgreement.rules.summary': 'Reglas de comisión configuradas para este acuerdo comercial.',
  'channelAgreement.rules.beneficiaryType': 'Beneficiario',
  'channelAgreement.rules.calculationType': 'Tipo de cálculo',
  'channelAgreement.rules.ruleFrequencyType': 'Frecuencia',
  'channelAgreement.rules.paymentIntervalSource': 'Intervalo de pago',
  'channelAgreement.rules.paymentIntervalSource.inherit': 'Heredar acuerdo',
  'channelAgreement.rules.paymentIntervalSource.replace': 'Reemplazar',
  'channelAgreement.rules.paymentIntervalSource.hint':
    'Heredar usa el intervalo del acuerdo. Reemplazar define valor y unidad propios.',
  'channelAgreement.rules.paymentIntervalSource.oneTime.hint':
    'Espera después del pago confirmado. Puede heredar el acuerdo. 0 = sin espera.',
  'channelAgreement.rules.paymentIntervalSource.recurring.hint':
    'Si el valor efectivo es mayor que 0, la unidad tiene que ser meses. Heredar un acuerdo en días con valor mayor que 0 no es válido: reemplace con meses o con 0.',
  'channelAgreement.rules.paymentIntervalValue': 'Valor',
  'channelAgreement.rules.paymentIntervalUnit': 'Unidad',
  'channelAgreement.rules.paymentInterval.payAfter': 'Pagar después de',
  'channelAgreement.rules.paymentInterval.payAfter.hint':
    '30 días no es 1 mes. El 31 de enero más 30 días cae el 2 de marzo; más 1 mes cae el 28 de febrero.',
  'channelAgreement.rules.paymentInterval.payEvery': 'Pagar cada',
  'channelAgreement.rules.paymentInterval.payEvery.hint':
    'Bloque de liquidación, no una espera de cada fila. Si el valor es mayor que 0, la unidad debe ser meses. 0 no abre bloque.',
  'channelAgreement.rules.subscriptionPeriodFrom': 'Desde el período',
  'channelAgreement.rules.subscriptionPeriodTo': 'Hasta el período',
  'channelAgreement.rules.subscriptionPeriod.hint':
    'Vacío = sin límite. 1 y 1 = solo el primero. Si informa hasta, desde es obligatorio y debe ser al menos 1. Hasta debe ser mayor o igual que desde.',
  'channelAgreement.rules.commissionPercent': '% Comisión',
  'channelAgreement.rules.fixedAmount': 'Monto fijo',
  'channelAgreement.rules.revenueType': 'Tipo de ingreso',
  'channelAgreement.rules.revenueType.hint':
    'Opcional. Si no elige uno, la regla aplica a cualquier tipo de ingreso.',
  'channelAgreement.rules.commissionBaseType': 'Base de comisión',
  'channelAgreement.rules.commissionBaseType.hint':
    'Único eje de base: neto, neto tras fees, bruto o margen.',
  'channelAgreement.rules.commissionComponentCode': 'Código de componente',
  'channelAgreement.rules.commissionComponentCode.hint':
    'Opcional, en kebab-case. Si lo deja vacío, se usa default.',
  'channelAgreement.rules.mrrFrom': 'MRR desde',
  'channelAgreement.rules.mrrTo': 'MRR hasta',
  'channelAgreement.rules.mrr.hint': 'Tramo [desde, hasta): el valor hasta no se incluye.',
  'channelAgreement.rules.automyPlan': 'Plan',
  'channelAgreement.rules.automyPlan.hint':
    'Opcional. Si no elige un plan, la regla no se limita a uno.',
  'channelAgreement.rules.scopeActorKind': 'Alcance por actor',
  'channelAgreement.rules.scopeActorKind.hint':
    'Opcional. Si no elige un tipo, la regla aplica a cualquier actor de este acuerdo.',
  'channelAgreement.rules.scopeActorCompanyId': 'Empresa del actor',
  'channelAgreement.rules.scopeActorCompanyId.hint':
    'Obligatorio si elige un tipo de actor. Debe ser una empresa de ese tipo.',
  'channelAgreement.rules.start': 'Inicio',
  'channelAgreement.rules.end': 'Fin',
  'channelAgreement.rules.isActive': 'Regla activa',
  'channelAgreement.rules.payoutSchedule': 'Programación de pagos',
  'channelAgreement.rules.payoutSchedule.payment': 'Pago {n}',
  'channelAgreement.rules.payoutSchedule.percent': 'Porcentaje',
  'channelAgreement.rules.payoutSchedule.offset': 'Después de',
  'channelAgreement.rules.payoutSchedule.months': 'Mes(es)',
  'channelAgreement.rules.payoutSchedule.month': 'mes',
  'channelAgreement.rules.payoutSchedule.monthsPlural': 'meses',
  'channelAgreement.rules.payoutSchedule.total': 'Total acumulado: {total}%',
  'channelAgreement.rules.payoutSchedule.add': 'Agregar pago',
  'channelAgreement.rules.payoutSchedule.placementHint':
    'Si necesitas dividir una misma comisión en varios pagos, usa Programación de pagos dentro de la misma regla.',
  'channelAgreement.rules.payoutSchedule.offsetHint':
    'El desfase no reemplaza al intervalo de pago ni al período de suscripción. Vacío significa un solo pago del 100% en el mes 0.',
  'channelAgreement.rules.payoutSchedule.error.percent':
    'Cada porcentaje debe ser mayor que 0 y menor o igual a 100.',
  'channelAgreement.rules.payoutSchedule.error.offset':
    'Los desfases de meses del calendario de pagos deben ser únicos, ascendentes y mayores o iguales a cero.',
  'channelAgreement.rules.payoutSchedule.error.sum':
    'Los porcentajes del calendario de pagos deben sumar 100.',
  'channelAgreement.rules.payoutSchedule.summary.empty': '100% · mes 0',
  'channelAgreement.rules.payoutSchedule.summary.item': '{percent}% · {offset} {months}',
  'channelAgreement.action.clone': 'Clonar acuerdo',
  'channelAgreement.action.createVersion': 'Crear nueva versión',
  'channelAgreement.version.message':
    '¿Crear una nueva revisión de este acuerdo? Quedará pendiente de aprobación de AUTOMY.',
  'channelAgreement.version.conflict':
    'Ya existe una versión pendiente de esta serie. Recarga el listado e inténtalo de nuevo.',
  'channelAgreement.columns.versionNumber': 'Versión',
  'channelAgreement.columns.agreementSeriesId': 'Serie',
  'channelAgreement.fields.supersedesAgreementId': 'Reemplaza a',
  'channelAgreement.review.approve.message': '¿Aprobar este acuerdo comercial?',
  'channelAgreement.review.reject.message': '¿Rechazar este acuerdo comercial?',
  'channelAgreement.review.notesPlaceholder': 'Notas de revisión',
  'channelAgreement.review.policyPlaceholder': 'Seleccione la política de registro',
  'channelAgreement.fields.registrationApprovalPolicy': 'Política de registro',
  'channelAgreement.fields.registrationApprovalPolicy.hint':
    'Define si el registro con este acuerdo se completa de inmediato o queda pendiente de AUTOMY.',
  'channelAgreement.registrationApprovalPolicy.notRequired': 'Aprobación de AUTOMY no requerida',
  'channelAgreement.registrationApprovalPolicy.automyApprovalRequired':
    'Registro sujeto a aprobación de AUTOMY',
  'channelPlan.columns.scope': 'Alcance',
  'channelPlan.columns.kind': 'Tipo',
  'channelPlan.columns.category': 'Categoría',
  'channelPlan.fields.tierRank': 'Rango de nivel',
  'channelPlan.fields.targetChannelActorKind': 'Actor de canal objetivo',
  'channelPlan.fields.exclusiveCompany': 'Empresa exclusiva',
  'channelPlan.fields.maxRequestsCount': 'Máx. solicitudes',
  'channelPlan.fields.isAzureAdEnabled': 'Azure AD habilitado',
  'channelPlan.fields.isDigitalSignatureEnabled': 'Firma digital habilitada',
  'channelPlan.fields.maxStorageGb': 'Almacenamiento máx. (GB)',
  'channelPlan.fields.monthlyOverageFee': 'Cuota mensual por exceso',
  'channelPlan.fields.aiMonthlyIncludedCreditAmount': 'Crédito mensual de IA incluido',
  'channelPlan.fields.instanceDataRetentionDays': 'Retención de datos de instancia (días)',
  'channelPlan.fields.maxEmailsCount': 'Máx. correos',
  'channelPlan.fields.maxIterationItemsCount': 'Máx. ítems de iteración',
  'channelPlan.fields.maxBulkTaskItemsCount': 'Máx. ítems de tarea masiva',
  'channelPlan.fields.maxEntitiesCount': 'Máx. entidades',
  'channelPlan.fields.maxDocumentGenerationCount': 'Máx. generaciones de documentos',
  'channelPlan.fields.allowedBillingModes': 'Modos de cobro permitidos',
  'channelPlan.fields.defaultBillingMode': 'Modo de cobro por defecto',
  'automyPlanScope.shared': 'Compartido',
  'automyPlanScope.companyExclusive': 'Exclusivo de empresa',
  'automyPlanScope.internal': 'Interno',
  'automyPlanKind.free': 'Gratuito',
  'automyPlanKind.trial': 'Prueba',
  'automyPlanKind.paid': 'De pago',
  'automyPlanKind.custom': 'Personalizado',
  'automyPlanKind.internal': 'Interno',
  'automyPlanCategory.unspecified': 'Sin especificar',
  'automyPlanCategory.free': 'Gratuito',
  'automyPlanCategory.trial': 'Prueba',
  'automyPlanCategory.starter': 'Starter',
  'automyPlanCategory.basic': 'Básico',
  'automyPlanCategory.business': 'Business',
  'automyPlanCategory.professional': 'Profesional',
  'automyPlanCategory.enterprise': 'Enterprise',
  'automyPlanCategory.digitalTransformation': 'Transformación digital',
  'automyPlanCategory.channel': 'Canal',
  'automyPlanCategory.custom': 'Personalizado',
  'automyPlanCategory.internal': 'Interno',
  'channelActorKind.none': 'Ninguno',
  'channelActorKind.automyInternal': 'Interno AUTOMY',
  'channelActorKind.operator': 'Operador',
  'channelActorKind.distributor': 'Distribuidor',
  'channelActorKind.partner': 'Partner',
  'channelActorKind.reseller': 'Reseller',
  'channelActorKind.customer': 'Cliente',
  'channelActorKind.referralAgent': 'Agente referidor',
  'global.text.accessLog': 'Registros de Acceso',
  'global.text.accessPolicies': 'Políticas de Acceso',
  'global.text.securityEvents': 'Eventos de seguridad',
  'global.text.shortenedUrls': 'URLs Abreviadas',
  'global.text.traces': 'Trazas',
  'global.text.emailMessageTraces': 'Trazas de Correo',
  'global.text.environments': 'Entornos',
  'global.text.teamsMessageTraces': 'Trazas de Mensajes Teams',
  'global.text.smsMessageTraces': 'Trazas de Mensajes SMS',
  'global.text.reportGroups': 'Grupos de Reportes',
  'global.text.reportTokens': 'Tokens de Reportes',
  'global.text.sequences': 'Secuencias',
  'reportGroups.title': 'Gestionar Grupos de Reportes',
  'global.text.config': 'Configurar',
  'global.text.processConfig': 'Configurar',
  'global.text.restricted': 'Restringido',
  'global.text.public': 'Público',
  'global.text.permissions': 'Permisos',
  'global.text.permissionsFiltersLogicalOperator': 'Operador Lógico Permisos',
  'global.text.menu': 'Menú',
  'global.text.validated': 'Validada',
  'global.text.notValidated': 'No Validada',
  'global.text.published': 'Publicada',
  'global.text.draft': 'Borrador',
  'global.text.server': 'Servidor',
  'global.text.byPosition': 'Por Puesto',
  'global.text.byUser': 'Por Usuario',
  'global.text.byGroup': 'Por Grupo',
  'global.text.byArea': 'Por Área',
  'global.text.userExit': 'Usuario existe',
  'global.text.positionExit': 'Puesto existe',
  'global.text.userGroupExit': 'Grupo de usuario existe',
  'global.text.token': 'Token',
  'global.text.apiKeySecret': 'Clave API Secreta',
  'global.text.fromPhoneNumber': 'Número de teléfono de origen',
  'global.text.process': 'Proceso',
  'global.text.web': 'Web',
  'global.text.mobile': 'Móvil',
  'global.text.webMobile': 'Web & Móvil',
  'global.text.action': 'Acción',
  'global.text.showBy': 'Mostrar por',
  'global.text.operation': 'Operación',
  'global.text.observation': 'Observación',
  'global.text.administrator': 'Administrador',
  'global.text.superAdministrator': 'Super Administrador',
  'global.text.copying': 'Copiado',
  'global.text.network.title': 'Excepción de red',
  'global.text.network.info': `No se pudo establecer conexión con el servidor. Por favor, verifique su conexión a internet e inténtelo nuevamente.`,
  'global.text.timeout.title': 'Solicitud Expirada',
  'global.text.timeout.info':
    'La solicitud ha tardado demasiado tiempo. Por favor, intente nuevamente.',
  'global.text.cors.title': 'Acceso Restringido',
  'global.text.cors.info':
    'No se pudo completar la operación debido a un problema al comunicarse con el servidor. Esto puede deberse a restricciones de seguridad del navegador o a la configuración de la red. Si el problema persiste, por favor contacte a soporte.',
  'global.text.loading': 'cargando',
  'global.text.providers': 'Proveedores',
  'global.text.verifyCode': 'Código de Verificación',
  'global.text.allowedFileFormats': 'Formatos',
  'global.text.startProcess': 'Iniciar',
  'global.text.reassignTask': 'Reasignar Tarea',
  'global.text.site': 'Portales',
  'global.text.app': 'AUTOMY',
  'global.text.start': 'Iniciar',
  'global.text.scheduled': 'Programado',
  'global.text.automated': 'Automatizado',
  'global.text.viewDetail': 'Ver detalle',
  'global.text.delete': 'Eliminar',
  'global.text.mode': 'Modo',
  'global.text.table': 'Tabla',
  'global.text.property': 'Propiedad',
  'global.text.loadingFiles': 'Cargando archivos',
  'global.text.fallback.location': 'ubicación Actual',
  'global.text.fileName': 'Nombre de Archivo',
  'global.text.pageSize': '{num} registros',
  'global.text.listRecordsCount': '{count} registros',
  'global.text.fields': 'Campos',
  'global.text.appClient': 'Aplicación Cliente',
  'global.text.selectedElements': 'Tienes {count} {elements} seleccionados',
  'global.text.elementSelected': 'elemento',
  'global.text.elementsSelected': 'elementos',
  'global.text.selectAll': 'Seleccionar todo',
  'global.text.engineVersion': 'Versión del Motor',
  'global.text.resource': 'Tipo de Recurso',
  'global.text.initBy': 'Iniciado Por',
  'global.text.orderBy': 'Ordenar',
  'global.text.entity': 'Entidad',
  'global.text.response': 'Respuesta',
  'global.text.operation': 'Operación',
  'global.text.dates': 'Fechas',
  'global.text.description': 'Descripción',
  'global.text.sp_call': 'Llamada SP',
  'global.text.order': 'Orden',
  'global.text.title': 'Título',
  'global.text.name': 'Nombre',
  'global.text.details': 'Detalles',
  'global.text.editor': 'Editor',
  'global.text.loading': 'Cargando',
  'global.text.isActive': 'Habilitado',
  'global.text.favorite': 'Favorito',
  'global.text.diagram': 'Diagrama',

  'global.text.english': 'Inglés',
  'global.text.spanish': 'Español',
  'global.text.language': 'Idioma',

  'global.text.context.company': 'Empresas',
  'global.text.context.environment': 'Entornos',
  'global.text.context.user': 'Mi Perfil',
  'global.text.context.site': 'Portales',
  'global.text.context.synced.title': 'Contexto actualizado',
  'global.text.context.synced.company':
    'Cambiaste de empresa en otra pestaña. Esta pestaña ahora trabaja en {name}.',
  'global.text.context.synced.environment':
    'Cambiaste de entorno en otra pestaña. Esta pestaña ahora trabaja en {name}.',
  'global.text.session.ended.title': 'Sesión cerrada',
  'global.text.session.ended.description':
    'Tu sesión se cerró en otra pestaña del navegador. Vuelve a iniciar sesión para continuar.',

  'global.text.plan': 'Plan',
  'global.text.partner': 'Socio',
  'global.text.commercialName': 'Nombre Comercial',
  'global.text.noIdentity': 'Nro. Identidad',
  'global.text.country': 'País',
  'global.text.roles': 'Roles',
  'global.text.channel': 'Canal',
  'global.text.distributor': 'Distribuidor',
  'global.text.reseller': 'Revendedor',

  'company.subscription.status.active': 'Activa',
  'company.subscription.status.pending-activation': 'Pendiente de activación',
  'company.subscription.status.pending-payment': 'Pendiente de pago',
  'company.subscription.status.past-due': 'Pago vencido',
  'company.subscription.status.suspended': 'Suspendida',
  'company.subscription.status.canceled': 'Cancelada',

  'company.channel.actor.none': 'Sin canal',
  'company.channel.actor.automy-internal': 'Interno AUTOMY',
  'company.channel.actor.operator': 'Operador',
  'company.channel.actor.distributor': 'Distribuidor',
  'company.channel.actor.partner': 'Socio',
  'company.channel.actor.reseller': 'Revendedor',
  'company.channel.actor.customer': 'Cliente',

  'company.role.owner': 'Propietario',
  'company.role.admin': 'Administrador',
  'company.role.billing-admin': 'Admin. Facturación',
  'company.role.commercial-admin': 'Admin. Comercial',
  'company.role.user-admin': 'Admin. Usuarios',
  'company.role.support': 'Soporte',
  'company.role.auditor': 'Auditor',
  'company.role.collaborator': 'Colaborador',
  'company.role.user': 'Usuario',
  'company.role.super-admin': 'Super Admin',

  'company.plan.tag.custom': 'Custom',
  'company.plan.tag.exclusive': 'Exclusivo',
  'company.plan.tag.internal': 'Interno',

  'global.text.upload.camera': 'Tomar una Foto',
  'global.text.upload.image': 'Haz clic o arrastra una imagen',
  'global.text.upload.file': 'Haz clic o arrastra un archivo',
  'global.text.upload.document': 'Haz clic o arrastra un documento',
  'global.text.upload.format.error':
    'Formato de archivo inválido. Por favor suba un archivo de Excel (.xlsx o .xls)',
  'global.text.upload.files': 'Haz clic o arrastra uno o más archivos',
  'global.text.upload.camera.compact': 'Foto',
  'global.text.upload.image.compact': 'Imagen',
  'global.text.upload.file.compact': 'Archivo',
  'global.text.upload.files.compact': 'Archivos',
  /* Details / view-only empty media (no action CTAs) */
  'global.text.upload.camera.emptyView': 'Sin foto',
  'global.text.upload.image.emptyView': 'Sin imagen',
  'global.text.upload.file.emptyView': 'Sin archivo',
  'global.text.upload.files.emptyView': 'Sin archivos',
  'global.field.signature.emptyView': 'Sin firma',
  'global.text.validate': 'Validar',

  'global.text.preview': 'Visualizar',
  'global.text.expand': 'Expandir',

  'vectorsUploader.subtitle.empty': 'Documentos para entrenar al agente',
  'vectorsUploader.subtitle.count': '{count} documentos · {size}',
  'vectorsUploader.action.add': 'Agregar documentos',
  'vectorsUploader.action.removeSelected': 'Eliminar {count} seleccionados',
  'vectorsUploader.search.placeholder': 'Filtrar documentos',
  'vectorsUploader.search.empty': 'Ningún documento coincide con "{q}"',
  'vectorsUploader.selection.selectAll': 'Seleccionar todos',
  'vectorsUploader.selection.summary': '{count} seleccionados',
  'vectorsUploader.empty.title': 'Sin documentos de entrenamiento',
  'vectorsUploader.empty.hint':
    'Agrega documentos para que el agente los use como base de conocimiento',
  'vectorsUploader.drop.title': 'Suelta los archivos aquí',
  'vectorsUploader.status.indexed': 'Indexado',
  'vectorsUploader.status.uploading': 'Subiendo',
  'vectorsUploader.status.uploadingPct': 'Subiendo · {pct}%',
  'vectorsUploader.status.error': 'Error',
  'global.text.editExpanded': 'Editar Expandido',
  'global.text.server': 'Servidor',
  'global.created.asc': 'Fecha Asc',
  'global.created.desc': 'Fecha Desc',
  'global.text.order.short.asc': 'Creación Asc',
  'global.text.order.short.desc': 'Creación Desc',

  'global.text.asc': 'Asc',
  'global.text.desc': 'Desc',

  'global.empty': 'No hay información para mostrar',
  'global.empty.processes': 'No tienes procesos que gestionar',
  'global.empty.source': 'Aún no has ingresado información para mostrar',
  'global.empty.pendingTasks': '¡Felicidades, no tienes tareas pendientes!',

  'global.paged.item5': '5 registros',
  'global.paged.items10': '10 registros',

  'global.status.active': 'Activos',
  'global.status.inactive': 'Inactivos',

  'global.tooltip.userGroup': 'Grupo de Usuarios',
  'global.tooltip.userEnviroment': 'Entornos de Usuario',

  'global.enable': 'Habilitar',
  'global.disable': 'Deshabilitar',
  'global.name': 'Nombre',
  'global.description': 'Descripción',
  'global.category': 'Categoría',
  'global.email': 'Correo',

  'global.method': 'Método',
  'global.parameters': 'Parámetros',
  'global.position': 'Posición',
  'global.noData': 'Sin datos',
  'global.authorizationType': 'Tipo de Authorización',
  'global.enabledElement': '¿Elemento Habilitado?',
  'global.default': 'Predeterminado',
  'global.emailAddress': 'Correo Electrónico',
  'global.email.subject': 'Asunto',
  'global.email.from': 'De',
  'global.email.to': 'Para',
  'global.email.replyTo': 'Responder A',
  'global.email.cc': 'CC',
  'global.email.bcc': 'BCC',
  'global.email.errorMessage': 'Mensaje de Error',
  'global.email.deliveryProvider': 'Proveedor de envío',
  'global.email.deliveryProvider.sendgrid': 'SendGrid',
  'global.email.deliveryProvider.smtp': 'SMTP',
  'global.email.deliveryProvider.sendGrid': 'SendGrid',
  'global.email.chatThread': 'Hilo de Chat',
  'global.email.chatThreadId': 'ID hilo de chat',
  'global.email.chatMessageId': 'ID Mensaje Chat',
  'global.email.otherEntity': 'Otra Entidad',
  'global.email.otherEntityDisplayName': 'Nombre Visible Otra Entidad',
  'global.email.otherEntityId': 'ID Otra Entidad',
  'global.email.otherEntityDisplayIdentifier': 'Identificador Visible Otra Entidad',
  'global.email.customArgs': 'Argumentos Personalizados',
  'global.email.smtpId': 'Smtp Id',
  'global.email.eventId': 'Evento Id',
  'global.email.messageId': 'Mensaje Id',
  'global.email.reason': 'Motivo',
  'global.email.userAgent': 'Agente de Usuario',
  'global.email.mailEventLongDescription': 'Descripción',
  'global.email.mailEventLongDescription0':
    'El mensaje ha sido recibido y está listo para ser entregado',
  'global.email.mailEventLongDescription1':
    'Es posible que observes las siguientes razones para el rechazo: Encabezado SMTPAPI inválido, contenido considerado spam (si la aplicación de verificación de spam está habilitada), dirección de correo dada de baja, dirección de correo rebotada, dirección marcada como spam, dirección inválida, lista de destinatarios que excede el límite del paquete',
  'global.email.mailEventLongDescription2':
    'El mensaje se ha entregado exitosamente al servidor receptor',
  'global.email.mailEventLongDescription3':
    'El servidor receptor no pudo o no quiso aceptar el correo para este destinatario de manera permanente. Si un destinatario se dio de baja previamente de tus correos, el mensaje se rechazará',
  'global.email.mailEventLongDescription4': 'El servidor receptor rechazó temporalmente el mensaje',
  'global.email.mailEventLongDescription5':
    'El destinatario ha abierto el mensaje HTML. Es necesario habilitar el seguimiento de aperturas para este tipo de evento',
  'global.email.mailEventLongDescription6':
    'El destinatario hizo clic en un enlace dentro del mensaje. Es necesario habilitar el seguimiento de clics para este tipo de evento',
  'global.email.mailEventLongDescription7':
    "El destinatario hizo clic en el enlace de 'Darse de baja de todos los correos' (disponible después de hacer clic en el enlace de gestión de suscripciones del mensaje). Es necesario habilitar el seguimiento de suscripciones para este tipo de evento",
  'global.email.mailEventLongDescription8':
    'El destinatario volvió a suscribirse a un grupo específico actualizando sus preferencias. Es necesario habilitar el seguimiento de suscripciones para este tipo de evento',
  'global.email.mailEventLongDescription9': 'El destinatario marcó el mensaje como spam',
  'global.emailEvent.unknown': 'Desconocido',
  'global.emailEvent.processed': 'Procesado',
  'global.emailEvent.dropped': 'Omitido',
  'global.emailEvent.delivered': 'Entregado',
  'global.emailEvent.bounce': 'Rebotado',
  'global.emailEvent.deferred': 'Diferido',
  'global.emailEvent.open': 'Abierto',
  'global.emailEvent.click': 'Clickeado',
  'global.emailEvent.unsubscribe': 'Unsuscrito',
  'global.emailEvent.resubscribe': 'Re-Subscripción',
  'global.emailEvent.spamReport': 'Reportado SPAM',
  'global.email.status.sent': 'Enviado',
  'global.email.status.badRequest': 'Error',
  'global.email.status.unauthorized': 'No autorizado',
  'global.email.status.forbidden': 'Permiso denegado',
  'global.email.status.notFound': 'No encontrado',
  'global.email.status.payloadTooLarge': 'Correo demasiado grande',
  'global.email.status.tooManyRequests': 'Límite de envíos alcanzado',
  'global.email.status.internalServerError': 'Error interno del servidor',
  'global.email.status.badGateway': 'Puerta de enlace inválida',
  'global.email.status.serviceUnavailable': 'Servicio no disponible',
  'global.email.status.gatewayTimeout': 'Tiempo de espera agotado',
  'global.email.status.unknown': 'Desconocido',
  'global.emailType.unknown': 'Desconocido',
  'global.emailType.processInstancePendingApproval': 'Solicitud / Aprobación Pendiente',
  'global.emailType.processInstancePendingCompleteInformation':
    'Solicitud / Completar Información Pendiente',
  'global.emailType.processInstancePendingTaskCompletion': 'Solicitud / Tarea Pendiente',
  'global.emailType.processInstancePendingSignature': 'Solicitud / Firma Pendiente',
  'global.emailType.processInstanceApprovalSecurityCode': 'Solicitud / Código de Aprobación',
  'global.emailType.processInstanceActionSendEmail': 'Solicitud / Acción Enviar Correo',
  'global.emailType.processInstanceNewCommentNotification':
    'Solicitud / Notificación Nuevo comentario',
  'global.emailType.processInstanceScheduledExecutionNotification':
    'Solicitud / Notificación Ejecución Programada',
  'global.emailType.processInstanceApprovedNotification':
    'Solicitud / Notificación Solicitud Aprobada',
  'global.emailType.processInstanceRejectedNotification':
    'Solicitud / Notificación Solicitud Rechazada',
  'global.emailType.processInstanceCanceledNotification':
    'Solicitud / Notificación Solicitud Cancelada',
  'global.emailType.processInstanceVoidedNotification':
    'Solicitud / Notificación Solicitud Anulada',
  'global.emailType.processInstanceWithErrorsNotification':
    'Solicitud / Notificación Solicitud con Errores',
  'global.emailType.userAccountConfirmation': 'Usuario / Confirmación de Cuenta',
  'global.emailType.userAccountWelcomeMessage': 'Usuario / Mensaje de Bienvenida',
  'global.emailType.userAccountResetPassword': 'Usuario / Cambiar Contraseña',
  'global.emailType.userAccountTwoFactorValidationCode':
    'Usuario / Código Autenticación dos Factores',
  'global.emailType.userAccountSecurityAlertNewLogin': 'Usuario / Alerta Nuevo Acceso',
  'global.emailType.internalTaskErrorNotification': 'Tarea Interna / Notificación Error',
  'global.emailType.internalTaskEntityFileReadyToDownloadNotification':
    'Tarea Interna / Notificación Fichero Entidad Dinámica Listo para Descargar',
  'global.emailType.internalTaskEntityFileImportFinishNotification':
    'Tarea Interna / Notificación Entidad Dinámica Importar Finalizado',
  'global.emailType.formFieldApiWithErrorsNotification':
    'Campo API de Formulario / Notificación API con Errores',
  'global.emailType.maintenanceCompanyDeactivationNotification':
    'Mantenimiento / Notificación Desactivación Empresa',
  'global.emailType.processInstanceReassigned': 'Solicitud / Tarea Reasignada',
  'global.emailType.systemReportInternalTaskCompletedNotification':
    'Tarea Interna / Notificación Finalizada',
  'global.emailType.taskAssigned': 'Tarea Asignada',
  'global.emailType.internalTaskDynamicEntityImportCompleted':
    'Tarea Interna / Notificación Entidad Dinámica Importar Completado',
  'global.emailType.agentEmailMessage': 'Agente / Mensaje de Correo',
  'global.emailType.internalTaskListFileReadyToDownloadNotification':
    'Tarea Interna / Notificación Fichero Lista Personalizada Listo para Descargar',
  'global.emailType.aiBillingBudgetAlertNotification': 'AI Billing / Alerta de presupuesto de IA',
  'global.emailType.aiBillingMonthlyCreditGrantedNotification':
    'AI Billing / Crédito mensual de IA otorgado',
  'global.password': 'Contraseña',
  'global.confirmPassword': 'Confirmar Contraseña',
  'global.order': 'Orden',
  'global.executionOrder': 'Orden de Ejecución',
  'global.isPublic': '¿Es Pública?',

  'global.uploadFile': 'Arrastre y Suelte un Archivo aquí o haga Clic',
  'global.enablePin': 'Habilitar PIN',
  'global.pinCode': 'Código PIN',
  'global.reportType': 'Tipo de Reporte',
  'global.tags': 'Etiquetas',
  'global.legend.separateWithSemicolon': 'Separe múltiples {items} con punto y coma (;).',
  'global.legend.separateWithComma': 'Separe múltiples {items} con coma (,).',
  'global.legend.items.tags': 'etiquetas',
  'global.legend.items.emails': 'correos',
  'global.legend.items.options': 'opciones',
  'global.legend.items.values': 'valores',
  'global.platform': 'Plataforma',
  'global.publisher': 'Publicado por',
  'global.isManaged': 'Gestionado',

  'global.user': 'Usuario',
  'global.system': 'Sistema',
  'global.key': 'Llave',
  'global.value': 'Valor',
  'global.type': 'Tipo',
  'global.title': 'Título',
  'global.databaseType': 'Tipo de Base de Datos',

  'global.role': 'Rol',
  'global.show': 'Mostrar',
  'global.created': 'Fecha de Creación',
  'global.updated': 'Fecha de Actualización',
  'global.userCreator': 'Usuario creador',
  'global.userModifier': 'Usuario actualizador',

  'global.of': 'de',
  'global.add': 'Agregar',

  'process.text.fileName': 'Nombre',
  'process.text.userCreator': 'Autor',
  'process.text.contentType': 'Tipo de Archivo',
  'process.text.options': 'Opciones',

  'global.text.status': 'Estado',
  'global.text.processGroup': 'Grupo Procesos',
  'global.text.receivedRequests': 'Solicitudes Recibidas',
  'global.text.myRequests': 'Mis Solicitudes',
  'global.text.requestOrigin': 'Origen',

  'global.text.queries': 'Consultas',
  'global.text.query': 'Consulta',
  'global.text.database': 'Base de Datos',

  'global.text.approved': 'Aprobado',
  'global.text.rejected': 'Rechazado',
  'global.text.signed': 'Firmado',
  'global.text.taskExecuted': 'Tarea Ejecutada',
  'global.text.saved': 'Guardada',
  'global.text.savedAndCompleted': 'Guardada y Completada',

  'global.text.processApprovalEvaluation': 'Proceso Aprobación Evaluación',
  'global.text.delegation': 'Delegación',
  'global.text.delegationRestored': 'Delegación Reasignada',
  'global.text.reassignedTask': 'Tarea Reasignada',
  'global.text.selfAssignedTask': 'Tarea Auto-asignada',

  'global.text.enabled': 'Habilitado',
  'global.text.disabled': 'Deshabilitado',
  'global.text.yes': 'Si',
  'global.text.no': 'No',
  'global.text.administrador': 'Administrador',
  'global.defaults': 'Predeterminados',
  'global.notDefaults': 'No Predeterminados',
  'global.text.criteria': 'Criterios',
  'global.text.note': 'Nota',
  'global.text.none': 'Ninguna',
  'global.text.minute': 'Minutos',
  'global.text.hour': 'Horas',
  'global.text.day': 'Días',
  'global.text.month': 'Mes',
  'global.text.month.january': 'Enero',
  'global.text.month.february': 'Febrero',
  'global.text.month.march': 'Marzo',
  'global.text.month.april': 'Abril',
  'global.text.month.may': 'Mayo',
  'global.text.month.june': 'Junio',
  'global.text.month.july': 'Julio',
  'global.text.month.august': 'Agosto',
  'global.text.month.september': 'Septiembre',
  'global.text.month.october': 'Octubre',
  'global.text.month.november': 'Noviembre',
  'global.text.month.december': 'Diciembre',
  'global.text.source': 'Fuente',
  'global.text.businessday': 'Día hábil',
  'global.title.addedUsers': 'Usuarios Agregados',
  'global.text.form': 'Formulario',
  'global.text.areas': 'Áreas',
  'global.text.approvers': 'Aprobadores',
  'global.text.approversUserGroup': 'Por grupo',
  'global.text.approversUserGroupPosition': 'Por grupo y puesto',
  'global.text.approversUserGroupArea': 'Por grupo y área',
  'global.text.positions': 'Puestos',
  'global.text.approversEntityUser': 'Por entidad',
  'global.text.approversEntityUserGroup': 'Por entidad y grupo',
  'global.text.approversEntityPosition': 'Por entidad y puesto',
  'global.text.approversEntityArea': 'Por entidad y área',
  'global.text.customListGroups': 'Grupos de Listas',
  'global.text.media': 'Media',
  'global.text.mediaCategories': 'Categorías de Media',
  'global.text.emailFormats': 'Formatos de Correo',
  'global.text.extraUserFields': 'Campos Extra de Usuario',
  'global.text.delegations': 'Delegaciones',
  'global.text.processPortal': 'Portales de Procesos',
  'global.text.dynamicEntityGroups': 'Grupos de Entidades Dinámicas',
  'global.text.processGroups': 'Grupos de Procesos',
  'global.text.connectionGroups': 'Grupos de Conexiones',
  'global.text.powerBiServers': 'Servidores Power BI',
  'global.text.aiAgentTeams': 'Equipos de Agentes IA',
  'global.text.aiSkillGroups': 'Grupos de Skills',
  'global.text.skills': 'Skills',
  'global.text.area': 'Área',
  'global.text.areaExit': 'Área Existe',
  'global.text.itemExists': 'Este elemento ya existe en la lista',
  'global.text.configuration': 'Configuración',
  'global.text.applicant': 'Solicitante',
  'global.text.select': 'Seleccione',

  'global.text.changePassword': 'Cambiar Contraseña',
  'global.text.twoFactor': 'Habilitar Two-Factor',
  'global.text.pushNotifications': 'Notificaciones',
  'global.text.logout': 'Cerrar Sesión',

  'global.text.company': 'Empresa',
  'global.text.owner': 'Propietario',
  'global.text.ownerCompany': 'Empresa propietaria',
  'global.text.agreement': 'Acuerdo',
  'global.text.canCreateCustomers': 'Puede crear clientes',
  'global.text.canCreatePartners': 'Puede crear socios',
  'global.text.canCreateResellers': 'Puede crear revendedores',
  'global.text.canCreateReferralAgents': 'Puede crear agentes referidores',
  'global.text.canCreateDistributors': 'Puede crear distribuidores',
  'global.text.partnerAgreementMode': 'Modo acuerdo socio',
  'global.text.defaultPartnerAgreement': 'Acuerdo socio por defecto',
  'global.text.defaultResellerAgreement': 'Acuerdo revendedor por defecto',
  'global.text.defaultReferralAgentsAgreement': 'Acuerdo agente referidor por defecto',
  'global.text.identity': 'Identidad',
  'global.text.commercialParent': 'Padre comercial',
  'global.text.shortCode': 'Código corto',
  'global.text.billingResponsibility': 'Responsabilidad de billing',
  'global.text.billingMode': 'Modo de billing',
  'global.text.currency': 'Moneda',
  'global.text.billingCycleType': 'Ciclo de facturación',
  'global.text.billingCycleCount': 'Cantidad de ciclos',
  'global.text.monthlyFee': 'Tarifa mensual',
  'global.text.paymentCollectionMode': 'Modo de cobro',
  'global.text.nextBillingDate': 'Próxima facturación',
  'global.text.autoRenew': 'Renovación automática',
  'global.text.customerChannelAssignment': 'Asignación de cliente',
  'global.text.defaultPaymentMethod': 'Método de pago predeterminado',
  'global.text.paymentTermsDays': 'Días de plazo de pago',
  'global.text.currentPeriodStart': 'Inicio del período actual',
  'global.text.currentPeriodEnd': 'Fin del período actual',
  'global.text.billingLegalName': 'Razón social',
  'global.text.billingTaxId': 'Identificación fiscal',
  'global.text.billingEmail': 'Email de facturación',
  'global.text.billingCountry': 'País de facturación',
  'global.text.billingAddressLine1': 'Dirección línea 1',
  'global.text.billingAddressLine2': 'Dirección línea 2',
  'global.text.billingCity': 'Ciudad',
  'global.text.billingState': 'Estado / Provincia',
  'global.text.billingPostalCode': 'Código postal',
  'global.text.stripeCustomerId': 'Stripe customer ID',
  'global.text.stripeSubscriptionId': 'Stripe subscription ID',
  'global.text.stripePriceId': 'Stripe price ID',
  'global.text.environment': 'Entorno',

  'channelEntityStatus.active': 'Activo',
  'channelEntityStatus.suspended': 'Suspendido',
  'channelEntityStatus.terminated': 'Terminado',
  'channelEntityStatus.pendingApproval': 'Pendiente de aprobación',
  'channelEntityStatus.rejected': 'Rechazado',

  'channelBillingMode.noBilling': 'Sin facturación',
  'channelBillingMode.providerAutomatic': 'Pago automático con tarjeta',
  'channelBillingMode.stripeAutomatic': 'Pago automático con tarjeta',
  'channelBillingMode.distributorCredit': 'Crédito de distribuidor',
  'channelBillingMode.manualInvoice': 'Facturación manual',

  'channelAgreementType.distributor': 'Distribuidor',
  'channelAgreementType.partner': 'Partner',
  'channelAgreementType.reseller': 'Revendedor',
  'channelAgreementType.referralAgent': 'Agente referidor',
  'channelAgreementType.operator': 'Operador',

  'distributorPartnerAgreementMode.automyManaged': 'Gestionado por AUTOMY',
  'distributorPartnerAgreementMode.distributorManaged': 'Gestionado por distribuidor',

  'resellerBillingResponsibility.customerPaysAutomyStripe': 'Cliente paga (Stripe AUTOMY)',
  'resellerBillingResponsibility.resellerPaysAutomy': 'Revendedor paga a AUTOMY',
  'resellerBillingResponsibility.manual': 'Manual',

  'billingSubscriptionStatus.pendingActivation': 'Pendiente de activación',
  'billingSubscriptionStatus.pendingPayment': 'Pendiente de pago',
  'billingSubscriptionStatus.active': 'Activa',
  'billingSubscriptionStatus.pastDue': 'Vencida',
  'billingSubscriptionStatus.canceled': 'Cancelada',
  'billingSubscriptionStatus.suspended': 'Suspendida',

  'billingCycleType.monthly': 'Mensual',
  'billingCycleType.quarterly': 'Trimestral',
  'billingCycleType.annual': 'Anual',

  'billingCollectionMode.automatic': 'Automático',
  'billingCollectionMode.manual': 'Manual',

  'billingPaymentMethodType.card': 'Tarjeta',
  'billingPaymentMethodType.bankAccount': 'Cuenta bancaria',
  'billingPaymentMethodType.invoice': 'Factura',

  'customerChannelSourceType.direct': 'Directo',
  'customerChannelSourceType.partner': 'Partner',
  'customerChannelSourceType.distributor': 'Distribuidor',
  'customerChannelSourceType.reseller': 'Revendedor',

  'currency.usd': 'USD',
  'global.text.search.company': 'Buscar empresa',
  'global.text.search.environment': 'Buscar entorno',
  'global.text.search.site': 'Buscar portal',

  'global.text.skip.reason': 'Motivo',
  'global.text.reject.reason': 'Motivo del Rechazo',
  'global.text.approve.reason': 'Observaciones Aprobación',
  'global.text.complete.reason': 'Observaciones Completado',
  'global.text.execute.reason': 'Observaciones Ejecución',
  'global.text.cancel.reason': 'Motivo de cancelación',
  'global.text.void.reason': 'Motivo de anulación',
  'global.text.delete.reason': 'Confirmar Eliminación',
  'global.text.delete.description': '¿Seguro que desea eliminar este elemento?',
  'global.text.backToAction': 'Retroceder a Acción',
  'global.text.goToAction': 'Adelantar a Acción',
  'global.text.actions': 'Acciones',
  'global.text.mapSearch': 'Buscar en mapa',
  'global.text.maps.geolocate': 'Pulse para centrar el mapa en su ubicación',
  'global.text.pin.approval.reason': 'PIN de Aprobación',

  'global.text.today': 'Hoy',
  'global.text.yesterday': 'Ayer',
  'global.text.last7Days': 'Últimos 7 días',
  'global.text.last15Days': 'Últimos 15 días',
  'global.text.last30Days': 'Últimos 30 días',
  'global.text.currentMonth': 'Mes Actual',
  'global.text.currentYear': 'Año Actual',
  'global.text.currentDay': 'Día Actual',
  'global.text.currentWeek': 'Semana Actual',
  'global.text.lastMonth': 'Mes Anterior',
  'global.text.last3Months': 'Últimos 3 Meses',
  'global.text.last6Months': 'Últimos 6 Meses',
  'global.text.last12Months': 'Últimos 12 Meses',
  'global.text.customRange': 'Rango Personalizado',

  'global.text.ongoingOps': 'Acciones en curso...',
  'global.text.ongoingOps.of': '{counter} de {count}',
  'global.text.configurations': 'Configuraciones',
  'global.text.void': 'Anular',

  'global.error.notAccessibleCamera':
    'La cámara esta bloqueada o no se puede acceder a ella.\n Por favor, permite la cámara en los permisos de tu navegador e inténtelo nuevamente.',
  'global.switchCamera': 'Cambiar cámara',
  'global.takePhoto': 'Tomar foto',
  'global.text.scanQr': 'Escanear código QR',
  'global.qr.centerCode': 'Centra el código QR dentro del marco',

  'global.message.processInstanceHasChanged':
    'El estado de la solicitud ha cambiado; ejecutando actualización!',
  'global.text.message.outOfBoundLocation':
    'La ubicación seleccionada esta fuera del area permitida',
  'global.text.message.mockLocationProvider':
    'Hemos detectado que estás utilizando una ubicación simulada. Esto no está permitido en nuestra aplicación, ya que afecta la precisión de los servicios que ofrecemos. Por favor, desactiva la simulación de ubicación y vuelve a intentarlo.',
  'global.message.securityCode': 'Código PIN de aprobación enviado satisfactoriamente',

  'global.attachment.type0': 'Desconocido',
  'global.attachment.type1': 'Imagen',
  'global.attachment.type2': 'Video',
  'global.attachment.type3': 'PDF',
  'global.attachment.type4': 'Documento Word',
  'global.attachment.type5': 'Hoja de Cálculo',
  'global.attachment.type6': 'Presentación',
  'global.attachment.type7': 'Proyecto Microsoft',
  'global.attachment.type8': 'Texto',
  'global.attachment.type9': 'Xml',
  'global.attachment.type10': 'Html',
  'global.attachment.type11': 'Json',
  'global.attachment.type12': 'Zip',
  'global.attachment.type13': 'Audio',
  'global.attachment.type14': 'Rar',
  'global.attachment.type15': 'Fuente',
  'global.attachment.type16': 'Texto Csv',

  'global.observation.type0': 'Observaciones',
  'global.observation.type1': 'Observaciones de Aprobación',
  'global.observation.type2': 'Motivo del Rechazo',

  'global.text.notValidFilePath': 'No es posible visualizar el archivo URL no válida.',
  'global.text.unsupportedFileType':
    'No es posible visualizar el archivo, tipo de archivo no soportado.',
  'global.text.unsupportedFileTypeHint':
    'No se puede previsualizar este tipo de archivo en el navegador. Puedes abrirlo en una nueva pestaña o descargarlo.',
  'global.text.linesCount': '{count} líneas',
  'global.text.filePreview.processing': 'Preparando vista previa…',
  'global.text.filePreview.tooLarge': 'Archivo grande',
  'global.text.filePreview.tooLargeHint':
    'El archivo es demasiado grande para formatearlo aquí. Se muestra un extracto; ábrelo o descárgalo para verlo completo.',
  'global.text.filePreview.officeTooLargeHint':
    'Este archivo supera el límite del visor en línea (~10 MB). Ábrelo en una nueva pestaña o descárgalo para verlo completo.',
  'global.text.filePreview.officeFailed': 'No se pudo cargar la vista previa',
  'global.text.filePreview.officeFailedHint':
    'El visor no respondió a tiempo. Puedes reintentar, abrir el archivo en una nueva pestaña o descargarlo.',
  'global.text.filePreview.officeUnreachableHint':
    'No se pudo acceder al archivo (la URL puede haber expirado). Ábrelo en una nueva pestaña o descárgalo; si persiste, vuelve a subir el archivo.',
  'global.text.filePreview.officeOpeningExcel': 'Abriendo con Excel para la web…',
  'global.text.filePreview.officeOpeningWord': 'Abriendo con Word para la web…',
  'global.text.filePreview.officeOpeningPowerPoint': 'Abriendo con PowerPoint para la web…',
  'global.text.filePreview.officeOpening': 'Abriendo con Office para la web…',
  'global.text.filePreview.officeLoadingDocument': 'Cargando documento…',
  'global.text.filePreview.officeSlowHint': 'Esto está tardando más de lo habitual.',
  'global.text.filePreview.officeMoreOptions': 'Más opciones',
  'global.text.filePreview.parquetRows': 'Primeras {count} filas',
  'global.text.filePreview.parquetRowsAll': '{count} filas',
  'global.text.filePreview.parquetRowsFiltered': '{shown} de {total} filas',
  'global.text.filePreview.parquetSearch': 'Buscar en la muestra',
  'global.text.filePreview.parquetSearchPlaceholder': 'Filtrar filas…',
  'global.text.filePreview.parquetNoMatches': 'Ninguna fila coincide con la búsqueda.',
  'global.text.filePreview.parquetEmpty': 'Este parquet no tiene filas para mostrar.',
  'global.text.filePreview.parquetError': 'No se pudo leer el archivo parquet.',
  'global.text.filePreview.parquetTooLargeHint':
    'Este parquet supera 32 MB. Descárgalo para inspeccionarlo.',
  'global.button.openNewTab': 'Abrir en una nueva pestaña',
  'global.text.form.placeholder': 'Por favor, rellene todos los campos requeridos',
  'global.text.importConfirm': '¿Desea eliminar los datos existentes?',

  'global.text.error.geolocation.failed': 'Error: El servicio de Geolocalización ha fallado.',
  'global.text.error.geolocation.support': 'Error: Su navegador no soporta Geolocalización.',
  'global.text.error.geolocation.denied': 'Error: Acceso a la localización denegado.',
  'global.text.error.video.support': 'Formato de video no soportado.',
  'global.text.error.audio.support': 'Formato de audio no soportado.',

  'global.error.title': 'Error',
  'global.error.404.title': 'Página no encontrada',
  'global.error.403.subTitle':
    'Permisos insuficientes. El usuario no tiene los permisos requeridos.',
  'global.error.404.subTitle': 'Pareces estar tratando de encontrar tu camino a casa',
  'global.error.default': 'La solicitud especificada ya no se encuentra disponible',
  'global.error.unknown': 'Ocurrió un error inesperado. Intente nuevamente.',

  'global.planType0': 'Prueba',
  'global.planType1': 'Socio',
  'global.planType2': 'Básico',
  'global.planType3': 'Negocio',
  'global.planType4': 'Empresa',
  'global.planType5': 'Personalizado',

  'global.displayText': 'Texto a mostrar',
  'global.internalName': 'Nombre interno',

  'global.field.text': 'Texto',
  'global.field.textMultiple': 'Texto Múltiple',
  'global.field.int': 'Entero',
  'global.field.int32': 'Entero',
  'global.field.decimal': 'Decimal',
  'global.field.boolean': 'Booleano',
  'global.field.dateTime': 'Fecha y Hora',
  'global.field.date': 'Fecha',
  'global.field.time': 'Hora',
  'global.field.choice': 'Selección',
  'global.field.dataBaseRemoteSearch': 'Búsqueda Remota de Base de Datos',
  'global.field.dataBaseRemoteList': 'Lista Remota de Base de Datos',
  'global.field.webServiceRemoteSearch': 'Búsqueda Remota de Servicio Web',
  'global.field.webServiceRemoteList': 'Lista Remota de Servicio Web',
  'global.field.databaseRemoteSearch': 'Búsqueda Remota de Base de Datos',
  'global.field.databaseRemoteList': 'Lista Remota de Base de Datos',
  'global.field.webserviceRemoteSearch': 'Búsqueda Remota de Servicio Web',
  'global.field.webserviceRemoteList': 'Lista Remota de Servicio Web',
  'global.field.selectorUser': 'Selector de Usuario',
  'global.field.selectorPosition': 'Selector de Puesto',
  'global.field.selectorUserGroup': 'Selector de Grupo de Usuarios',
  'global.field.table': 'Tabla',
  'global.field.attachment': 'Adjunto',
  'global.field.file': 'Archivo',
  'global.field.autoCalculatedByTableColumn': 'Calculado por Tabla',
  'global.field.fieldDynamicEntityList': 'Lista Entidad Dinamica',
  'global.field.calculatedByFormula': 'Calculado por Fórmula',
  'global.field.image': 'Imagen',
  'global.field.photo': 'Foto',
  'global.field.signature': 'Firma',
  'global.field.goToAction': 'Ir a Acción',
  'global.field.slider': 'Deslizador',
  'global.field.fieldDynamicEntitySearch': 'Búsqueda Entidad Dinamica',
  'global.field.selectorArea': 'Selector de Área',
  'global.field.radioGroup': 'Grupo de Opciones / Selección Simple',
  'global.field.checkGroup': 'Grupo de Opciones / Selección Múltiple',
  'global.field.url': 'Dirección URL',
  'global.field.location': 'Ubicación',
  'global.field.internalEntity': 'Entidad Interna',
  'global.field.intNumber': 'Número Entero',
  'global.field.decimalNumber': 'Número Decimal',
  'global.field.yesNo': 'Si/No',
  'global.field.email': 'Email',
  'global.field.password': 'Contraseña',
  'global.field.or': 'OR',
  'global.field.and': 'AND',

  'global.text.dragDrop': 'Arrastra y suelta o haz clic para reemplazar',
  'global.text.deleteData': 'Eliminar datos existentes',
  'global.text.selectFile': 'Por favor selecciona un archivo',
  'global.button.loadFile': 'Cargar Fichero',
  'global.text.auditor': 'Auditor',
  'global.text.collaborator': 'Colaborador',
  'global.text.userManager': 'Gestor de Usuarios',
  'global.text.content': 'Contenido',
  'global.error.import.data': 'Fila {rowNumber}: {errorMessage}',
  'global.error.import.multiple':
    'Se encontraron {errorCount} errores en la importación. Revisa los detalles a continuación.',
  'global.error.import.detailed':
    'Se encontraron {errorCount} errores en {rowsWithErrors} filas. {originalMessage}',
  'global.text.support': 'Soporte',
  'global.text.row': 'Fila',
  'global.text.column': 'Columna',
  'global.text.id': 'ID',
  'global.text.field': 'Campo',
  'global.text.error': 'Error',
  'global.text.warning': 'Atención',
  'global.text.information': 'Información',
  'global.field.ascending': 'Ascendente',
  'global.field.descending': 'Descendente',
  'global.field.none': 'No Agrupar',
  'global.field.value': 'Valor',
  'global.field.displayText': 'Texto de Visualización',
  'global.field.development': 'Desarrollo',
  'global.field.testing': 'Pruebas',
  'global.field.production': 'Producción',

  'global.text.columnOrderDirection.ascending': 'Ascendente',
  'global.text.columnOrderDirection.descending': 'Descendente',
  'global.text.responseGroupingType.none': 'Ninguno',
  'global.text.responseGroupingType.value': 'Valor',
  'global.text.responseGroupingType.displayText': 'Texto a Mostrar',

  // User Role translations
  'global.role.RoleAdmin': 'Administrador',
  'global.role.RoleSuperAdmin': 'Super Administrador',
  'global.role.RoleSupport': 'Soporte',
  'global.role.RoleUser': 'Usuario',
  'global.role.RoleCollaborator': 'Colaborador',
  'global.role.RoleAuditor': 'Auditor',
  'global.role.RoleUserManager': 'Gestor de Usuarios',
  'global.role.RolePartner': 'Socio',
  'global.role.RoleGuest': 'Invitado',
  'global.role.admin': 'Administrador',
  'global.role.super-admin': 'Super Administrador',
  'global.role.support': 'Soporte',
  'global.role.user': 'Usuario',
  'global.role.collaborator': 'Colaborador',
  'global.role.auditor': 'Auditor',
  'global.role.user-admin': 'Gestor de Usuarios',
  'global.role.partner': 'Socio',
  'global.role.guest': 'Invitado',

  // RoleName enum translations (global)
  'roleName.engine': 'Motor',
  'roleName.apiServer': 'Servidor API',
  'roleName.chatApiServer': 'Servidor API de Chat',
  'roleName.dataApiServer': 'Servidor API de Datos',
  'roleName.externalSystemProvider': 'Proveedor de Sistema Externo',
  'roleName.automyAgent': 'Agente Automy',
  'roleName.externalUser': 'Usuario Externo',
  'roleName.automyProcessPortal': 'Portal de Procesos Automy',
  'roleName.automyApp': 'Aplicación Automy',
  'roleName.automySite': 'Sitio Automy',
  'roleName.superAdmin': 'Super Administrador',
  'roleName.owner': 'Propietario',
  'roleName.admin': 'Administrador',
  'roleName.billingAdmin': 'Administrador de Facturación',
  'roleName.commercialAdmin': 'Administrador Comercial',
  'roleName.userAdmin': 'Gestor de Usuarios',
  'roleName.support': 'Soporte',
  'roleName.auditor': 'Auditor',
  'roleName.partner': 'Socio',
  'roleName.collaborator': 'Colaborador',
  'roleName.user': 'Usuario',
  'roleName.guest': 'Invitado',

  'global.profile.photo.upload.success': 'Foto de perfil actualizada correctamente',
  'global.profile.photo.upload.error': 'Error al actualizar la foto de perfil',

  // Connection error messages
  'global.error.connection.noRedirectUrl':
    'No se recibió URL de redirección del endpoint de autorización',
  'global.error.connection.noConnectionId': 'No se retornó ID de conexión de la creación',
  'global.error.connection.invalidStateFormat': 'Formato de estado inválido - se esperaba GUID',
  'global.error.connection.redirectedToAuthorization': 'Redirigido a autorización externa',

  // Password validation messages
  'global.error.password.confirmMismatch': 'Confirmar contraseña, no coincide',
  'global.error.password.sameAsCurrent': 'La contraseña nueva debe ser diferente a la actual',

  // Automy AI Chat errors
  'global.error.automyAI.noResults': 'No se encontraron resultados de Automy IA',
  'global.error.automyAI.noThreadId': 'No se encontró el ID del hilo de conversación',
  'global.error.automyAI.openChat': 'Error al abrir la conversación de Automy IA',

  // Global bulk delete translations - can be reused by any module
  'global.bulk.delete.success':
    'Se {eliminated} {successCount} {successElement} de {total} {totalElement}. Hubo {errorCount} {errorElement} que no {couldNotBeDeleted}.',
  'global.bulk.delete.error.only': 'Hubo {errorCount} {errorElement} que no {couldNotBeDeleted}.',
  'global.bulk.delete.errors.title': 'Errores de Eliminación',
  'global.errors.title': 'Errores',
  'global.import.errors.title': 'Errores de Importación',
  'global.import.result.title': 'Resultado de importación',
  'global.bulk.delete.eliminated.singular': 'eliminó',
  'global.bulk.delete.eliminated.plural': 'eliminaron',
  'global.bulk.delete.element.singular': 'elemento',
  'global.bulk.delete.element.plural': 'elementos',
  'global.bulk.delete.could.not.be.deleted.singular': 'no pudo ser eliminado',
  'global.bulk.delete.could.not.be.deleted.plural': 'no pudieron ser eliminados',

  // Generic image messages for reusable components
  'global.image.upload.title': 'Subir imagen',
  'global.image.change.title': 'Cambiar imagen',
  'global.image.upload.no.file': 'Por favor selecciona una imagen primero',
  'global.image.upload.error': 'Error al procesar la imagen',
  'global.image.upload.invalid.type': 'Solo puedes subir archivos de imagen',
  'global.image.upload.invalid.size': 'La imagen debe ser menor a 5MB',
  'global.image.upload.formats': 'PNG, JPG, GIF hasta 5MB',
  'global.image.rotate.left': 'Rotar a la izquierda',
  'global.image.rotate.right': 'Rotar a la derecha',
  'global.image.drag.instruction': 'Arrastra la imagen para ajustar la vista previa',
  'global.image.select.different': 'Seleccionar otra imagen',

  // Date formats
  'global.date.format': 'DD/MM/YYYY',

  // HTTP Response Status Codes
  'global.httpResponseStatusCode.100': 'Continuar',
  'global.httpResponseStatusCode.101': 'Cambio de Protocolos',
  'global.httpResponseStatusCode.200': 'OK',
  'global.httpResponseStatusCode.201': 'Creado',
  'global.httpResponseStatusCode.202': 'Aceptado',
  'global.httpResponseStatusCode.203': 'Información No Autoritativa',
  'global.httpResponseStatusCode.204': 'Sin Contenido',
  'global.httpResponseStatusCode.205': 'Restablecer Contenido',
  'global.httpResponseStatusCode.206': 'Contenido Parcial',
  'global.httpResponseStatusCode.300': 'Múltiples Opciones',
  'global.httpResponseStatusCode.301': 'Movido Permanentemente',
  'global.httpResponseStatusCode.302': 'Encontrado',
  'global.httpResponseStatusCode.303': 'Ver Otro',
  'global.httpResponseStatusCode.304': 'No Modificado',
  'global.httpResponseStatusCode.305': 'Usar Proxy',
  'global.httpResponseStatusCode.306': 'No Utilizado',
  'global.httpResponseStatusCode.307': 'Redirección Temporal',
  'global.httpResponseStatusCode.400': 'Solicitud Incorrecta',
  'global.httpResponseStatusCode.401': 'No Autorizado',
  'global.httpResponseStatusCode.402': 'Pago Requerido',
  'global.httpResponseStatusCode.403': 'Prohibido',
  'global.httpResponseStatusCode.404': 'No Encontrado',
  'global.httpResponseStatusCode.405': 'Método No Permitido',
  'global.httpResponseStatusCode.406': 'No Aceptable',
  'global.httpResponseStatusCode.407': 'Autenticación de Proxy Requerida',
  'global.httpResponseStatusCode.408': 'Tiempo de Solicitud Agotado',
  'global.httpResponseStatusCode.409': 'Conflicto',
  'global.httpResponseStatusCode.410': 'Desaparecido',
  'global.httpResponseStatusCode.411': 'Longitud Requerida',
  'global.httpResponseStatusCode.412': 'Precondición Fallida',
  'global.httpResponseStatusCode.413': 'Entidad de Solicitud Demasiado Grande',
  'global.httpResponseStatusCode.414': 'URI de Solicitud Demasiado Larga',
  'global.httpResponseStatusCode.415': 'Tipo de Medio No Soportado',
  'global.httpResponseStatusCode.416': 'Rango Solicitado No Satisfactorio',
  'global.httpResponseStatusCode.417': 'Expectativa Fallida',
  'global.httpResponseStatusCode.426': 'Actualización Requerida',
  'global.httpResponseStatusCode.500': 'Error Interno del Servidor',
  'global.httpResponseStatusCode.501': 'No Implementado',
  'global.httpResponseStatusCode.502': 'Puerta de Enlace Incorrecta',
  'global.httpResponseStatusCode.503': 'Servicio No Disponible',
  'global.httpResponseStatusCode.504': 'Tiempo de Puerta de Enlace Agotado',
  'global.httpResponseStatusCode.505': 'Versión HTTP No Soportada',

  // RunCode Operation Status
  'global.runCodeOperationStatus.1': 'Pendiente',
  'global.runCodeOperationStatus.2': 'Instalando',
  'global.runCodeOperationStatus.3': 'Ejecutando',
  'global.runCodeOperationStatus.4': 'Completado',
  'global.runCodeOperationStatus.5': 'Fallido',
  'global.runCodeOperationStatus.6': 'Expirado',
  'global.runCodeOperationStatus.7': 'Error',
  'global.runCodeOperationStatus.8': 'No Encontrado',

  // Process Config
  'process.config.version': 'Versión',
  'process.config.versionSelectorDisabled':
    'El selector de versiones estará disponible próximamente',

  'global.text.column.extraSmall': 'Extra Pequeño',
  'global.text.column.small': 'Pequeño',
  'global.text.column.medium': 'Mediano',
  'global.text.column.large': 'Grande',

  'global.dynamicEntityVersionOperation.generateTokenReadOnly': 'Generar Token de Lectura',
  'global.dynamicEntityVersionOperation.generateTokenWrite': 'Generar Token de Escritura',
  'global.dynamicEntityVersionOperation.appendComponent': 'Adicionar Componente',
  'global.dynamicEntityVersionOperation.modifyComponent': 'Actualizar Componente',
  'global.dynamicEntityVersionOperation.removeComponent': 'Eliminar Componente',
  'global.dynamicEntityVersionOperation.publish': 'Publicar',
  'global.dynamicEntityVersionOperation.newVersionCreated': 'Nueva Version Creada',

  'global.userDisplayValue.full-name': 'Nombre Completo',
  'global.userDisplayValue.email': 'Correo Electrónico',
  'global.userDisplayValue.extra-field': 'Campo Extra',
  'global.userDisplayValue.position': 'Posición',
  'global.userDisplayValue.area': 'Area',

  // Clipbord
  'global.clipboard.copied': 'Copiado al portapapeles',
  'global.clipboard.error': 'Error al copiar al portapapeles',

  'actions.type.default': 'Acción del proceso',
  'actions.type.defaultInitial': 'Predeterminado',
  'actions.type.completeInformation': 'Completar Información',
  'actions.type.approval': 'Aprobación',
  'actions.type.autoApprove': 'Aprobación Automática',
  'actions.type.conditional': 'Condicional',
  'actions.type.executeTask': 'Ejecutar Tarea',
  'actions.type.executeApiCall': 'Ejecutar Llamada API',
  'actions.type.autoReject': 'Rechazo Automático',
  'actions.type.digitalSignature': 'Firma Digital',
  'actions.type.sendEmail': 'Enviar Correo',
  'actions.type.executeQuery': 'Ejecutar Consulta de Base de Datos',
  'actions.type.dynamicEntityOperation': 'Operación sobre Entidad Dinámica',
  'actions.type.generateExcel': 'Generar Excel',
  'actions.type.startProcessInstance': 'Iniciar Proceso',
  'actions.type.setVariableData': 'Establecer Variable',
  'actions.type.setFormData': 'Establecer Datos de Formulario',
  'actions.type.parallel': 'Paralelo',
  'actions.type.generateDocuments': 'Generar Documentos',
  'actions.type.scheduledExecution': 'Ejecución Programada',
  'actions.type.sharePointOperation': 'Operación en SharePoint',
  'actions.type.iterate': 'Iterar / Aplicar a cada uno',
  'actions.type.switch': 'Switch',
  'actions.type.internalOperation': 'Operación Interna',
  'actions.type.generatePlainTextFile': 'Generar Fichero Texto',
  'actions.type.importPlainTextFile': 'Importar Archivo de Texto sin Formato',
  'actions.type.consumeSequence': 'Consumir Secuencia',
  'actions.type.executeRpaFlow': 'Ejecutar Flujo RPA',
  'actions.type.integration': 'Integración',
  'actions.type.autoCancel': 'Cancelar Automático',
  'actions.type.autoVoid': 'Anular Automático',
  'actions.type.openAi': 'Open AI',
  'actions.type.executeProcessAction': 'Ejecutar Acción Proceso',
  'actions.type.googleIntegration': 'Integración Google',
  'actions.type.revertCancellation': 'Revertir Cancelación',
  'actions.type.revertVoiding': 'Revertir Anulación',
  'actions.type.ftpOperation': 'Operación FTP',
  'actions.type.runCode': 'Ejecutar Código',
  'actions.type.automyAi': 'Automy IA',
  'actions.type.whatsAppBusinessIntegration': 'Integración WhatsApp Business',
  'actions.type.microsoftTeamsIntegration': 'Integración Microsoft Teams',

  'accessPolicy.effect.allow': 'Permitir',
  'accessPolicy.effect.deny': 'Denegar',

  'global.text.number': 'Número',
  'global.text.operationType': 'Tipo de Operación',
  'global.text.observations': 'Observaciones',
  'global.text.processingDate': 'Fecha de Procesamiento',
  'global.text.processedDate': 'Fecha de Procesado',
  'global.text.processingAttempts': 'Intentos de Procesamiento',
  'global.text.scheduledDate': 'Fecha Programada',
  'global.text.taskParameters': 'Parámetros de tarea',
  'global.text.alertEmails': 'Correos de alerta',
  'global.text.lastProcessingHeartbeat': 'Último heartbeat de procesamiento',
  'global.text.processingNodeId': 'ID nodo de procesamiento',
  'global.text.processingNodeName': 'Nombre nodo de procesamiento',
  'global.text.importance': 'Importancia',
  'global.text.dependsOnTaskNumber': 'Tarea dependiente',

  'internalTaskStatus.pending': 'Pendiente',
  'internalTaskStatus.processing': 'Procesando',
  'internalTaskStatus.processed': 'Procesado',
  'internalTaskStatus.error': 'Error',
  'internalTaskStatus.skipped': 'Omitido',
  'internalTaskStatus.cancelled': 'Cancelado',
  'internalTaskStatus.failed': 'Fallido',
  'internalTaskStatus.paused': 'Pausada',
  'internalTaskStatus.unknown': 'Desconocido',
  'config.info.createdBy': 'Creado por',
  'config.info.updatedBy': 'Modificado por',
  'config.info.creationDate': 'Fecha de creación',
  'config.info.formId': 'ID de formulario',
  'config.info.processId': 'ID de proceso',
  'config.publish.notAvailable': 'La publicación aún no está disponible',

  'accessControl.title': 'Control de acceso',
  'accessControl.users': 'Usuarios',
  'accessControl.userGroups': 'Grupos de usuario',
  'accessControl.positions': 'Puestos',
  'accessControl.areas': 'Áreas',
  'accessControl.filtersLogicalOperator': 'Operador entre secciones',
  'accessControl.userGroupsFiltersLogicalOperator': 'Operador entre grupos y otras secciones',
  'global.logicalOperator.and': 'Y (todos deben cumplirse)',
  'global.logicalOperator.or': 'O (al menos uno)',
};
